// noinspection SillyAssignmentJS,UnnecessaryLocalVariableJS

import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Card from "@material-tailwind/react/Card";
import CardBody from "@material-tailwind/react/CardBody";
import { BiArrowBack, BiPrinter, BiTrash } from "react-icons/bi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Loading from "../../../components/loading/Loading";
import Select from "react-select";
import NumberFormat from "react-number-format";
import { normalizeDetail } from "./normalizeDetail.js";
import { openSupportingFile } from "../shipping-manifest/supportingFile";
import {
  getMinRoom,
  roomSelector,
} from "../../../features/master/room/roomSlice";
import {
  addJobRequestTransaksiSelector,
  changeResponseSucess,
  getJobRequestDetailActivity,
  updateActivity,
} from "../../hrd/transaksi/job-request/AddjobRequestTransaksiSlice";
import {
  getMinKendaraan,
  kendaraanSelector,
} from "../../master/kendaraan/kendaraanSlice";
import { getMinOum, OumSelector } from "../../master/oum/oumSlice";

import moment from "moment";
import { getMinJetty, jettySelector } from "../../master/jetty/jettySlice";

import { Colors } from "../../../assets/Colors";
import {
  getMinKemasan,
  kemasanSelector,
} from "../../master/kemasan/kemasanSlice";
import { getMinLabour, labourSelector } from "../../master/labour/labourSlice";
import {
  getQuatationOperasional,
  quatationOperasionalSelector,
} from "../quatation/quatationOperasionalSlice";
import {
  getMinLimbah,
  limbahSelector,
} from "../../../features/master/limbah/limbahSlice";
import {
  getMinTypeOfClothing,
  typeOfClothingSelector,
} from "../../master/type-of-clothing/typeOfClothingSlice";
import { getMinGudang, gudangSelector } from "../../master/gudang/gudangSlice";
import { fuelSelector, getMinFuel } from "../../master/fuel/fuelSlice";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import { Modal, ModalBody } from "@material-tailwind/react";
import {
  distentionSelector,
  getMinDistention,
} from "../../master/distention/distentionSlice";
import { objectDrawer, SortingPORT_Services } from "./OperationalOutputCommon";
import {
  formatInputNumber,
  parseNumberInput,
  formatNumberWithSeparator,
} from "./numberFormatter";
// moment.tz.setDefault("Asia/Jakarta");
function isRequired(value) {
  let status = false;
  if (value !== null) {
    if (typeof value === "number") {
      if (value !== -1) {
        status = true;
      }
    }
  }
  return status;
}

function useForm(initialState = {}, validations = [], onSubmit = () => {}) {
  const { isValid: initialIsValid, errors: initialErrors } = validate(
    validations,
    initialState,
  );
  const [changed, setChanged] = useState(false);
  const [values, setValues] = useState(initialState);
  const [errors, setErrors] = useState(initialErrors);
  const [isValid, setValid] = useState(initialIsValid);
  const [touched, setTouched] = useState({});
  const changeHandler = (event) => {
    const newValues = { ...values, [event.target.name]: event.target.value };
    const { isValid, errors } = validate(validations, newValues);
    setChanged(true);
    setValues(newValues);
    setValid(isValid);
    setErrors(errors);
    setTouched({ ...touched, [event.target.name]: true });
  };

  const changeHandlerCargodoring = (event, dex, subdex, i) => {
    let tempdata = JSON.parse(JSON.stringify(values.Activity));
    if (subdex === -1) {
      tempdata[dex].Detail[i][event.target.name] = event.target.value;
      changeHandlerActivity(tempdata);
    } else {
      if (tempdata) {
        tempdata[dex].DetailActivity[subdex]["Detail"][i][event.target.name] =
          event.target.value;
        tempdata[dex].DetailActivity[subdex]["Detail"][i]["Total"] =
          tempdata[dex].DetailActivity[subdex]["Detail"][i]["Unloading"];
        changeHandlerActivity(tempdata);
        // tempdata.map(
        //   ({ DetailActivity }, index) =>
        //     DetailActivity!==null &&
        //     DetailActivity.map((subItem, subIndex) => {
        //       if (
        //         subItem["Name"] === "Stevedoring" ||
        //         subItem["Name"] === "Cargodoring" ||
        //         subItem["Name"] === "Delivery"
        //       ) {
        //         tempdata[index].DetailActivity[subIndex]["Detail"][i][
        //           event.target.name
        //         ] = event.target.value;
        //         tempdata[index].DetailActivity[subIndex]["Detail"][i]["Total"] =
        //           tempdata[index].DetailActivity[subIndex]["Detail"][i][
        //             "Unloading"
        //           ];
        //       }
        //
        //     })
        // );
      }
    }
  };

  const changeHandlerTimeoum = (name, value, dex, subdex, i) => {
    let tempdata = JSON.parse(JSON.stringify(values.Activity));
    // value = moment.utc(value);
    if (subdex === -1) {
      tempdata[dex].Detail[i][name] = value;
      changeHandlerActivity(tempdata);
    } else {
      if (tempdata) {
        tempdata[dex].DetailActivity[subdex]["Detail"][i][name] = value;
        changeHandlerActivity(tempdata);
      }
    }
  };
  const changeHandlerTimeoumWSM = (name, value, dex, subdex, i, add) => {
    let tempdata = JSON.parse(JSON.stringify(values.Activity));
    if (subdex === -1) {
      tempdata[dex].Detail[i][name] = value;
      tempdata[dex].Detail[i]["form8"] = add;

      changeHandlerActivity(tempdata);
    } else {
      if (tempdata) {
        tempdata[dex].DetailActivity[subdex]["Detail"][i]["form8"] = add;
        tempdata[dex].DetailActivity[subdex]["Detail"][i][name] = value;
        changeHandlerActivity(tempdata);
      }
    }
  };

  const changeHandlerActivity = (data) => {
    const newValues = { ...values, Activity: data };
    const { isValid, errors } = validate(validations, newValues);
    setChanged(true);
    setValues(newValues);
    setValid(isValid);
    setErrors(errors);
  };

  const editHandler = (initValues) => {
    const newValues = {
      ...values,
      NamaKlien: initValues.NamaKlien,
      PermitToWork: initValues.PermitToWork,
      ShippingManifest: initValues.ShippingManifest,
      ShippingManifestDetail: initValues.ShippingManifestDetail,
      QuatationNo: initValues.QuatationNo,
      SPKNo: initValues.SPKNo,
      KlienID: initValues.KlienID,
      Priority: initValues.Priority,
      StatusKet: initValues.StatusKet,
      Activity: initValues.Activity,
      Status: initValues.Status,
      TrucksEntry: initValues.TrucksEntry,
      Labour: initValues.Labour,
      Equipment: initValues.Equipment,
      RequestUnit: initValues.RequestUnit,
    };
    setValues(newValues);
  };

  const editDetail = (value) => {
    const newValues = {
      ...values,
      Activity: value.Activity,
    };
    setValues(newValues);
  };

  const editEquipment = (value) => {
    const newValues = {
      ...values,
      Equipment: value,
    };
    setValues(newValues);
  };

  const editLabour = (value) => {
    const newValues = {
      ...values,
      Labour: value,
    };
    setValues(newValues);
  };

  const editTrucksEntry = (value) => {
    const newValues = {
      ...values,
      TrucksEntry: value,
    };
    setValues(newValues);
  };

  const clearHandler = () => {
    setValues(initialState);
  };

  const submitHandler = (event) => {
    event.preventDefault();
    onSubmit(values);
  };
  return {
    values,
    editTrucksEntry,
    changeHandlerCargodoring,
    changeHandler,
    editHandler,
    changeHandlerTimeoum,
    changeHandlerTimeoumWSM,
    editDetail,
    clearHandler,
    isValid,
    errors,
    editEquipment,
    touched,
    submitHandler,
    editLabour,
    changeHandlerActivity,
  };
}

function validate(validations, values) {
  const errors = validations
    .map((validation) => validation(values))
    .filter((validation) => typeof validation === "object");
  return {
    isValid: errors.length === 0,
    errors: errors.reduce((errors, error) => ({ ...errors, ...error }), {}),
  };
}

const NumberInputField = ({ value, onChange, name, className, ...props }) => {
  const [displayValue, setDisplayValue] = useState("");
  const [isTyping, setIsTyping] = useState(false);

  // Set nilai awal / dari parent
  useEffect(() => {
    if (isTyping) return;

    if (value !== null && value !== undefined && value !== "") {
      const num = Number(value);
      if (!isNaN(num)) {
        setDisplayValue(
          num.toLocaleString("id-ID", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }),
        );
      }
    } else {
      setDisplayValue("");
    }
  }, [value, isTyping]);

  const handleChange = (e) => {
    setIsTyping(true);

    const input = e.target.value;
    setDisplayValue(input);

    // bersihkan untuk dikirim ke parent
    const clean = input.replace(/\./g, "").replace(",", ".");
    const parsed = parseFloat(clean);

    if (onChange && name) {
      onChange({
        target: {
          name,
          value: isNaN(parsed) ? "" : parsed,
        },
      });
    }
  };

  const handleBlur = () => {
    setIsTyping(false);

    if (!displayValue) return;

    const clean = displayValue.replace(/\./g, "").replace(",", ".");
    const parsed = parseFloat(clean);

    if (!isNaN(parsed)) {
      setDisplayValue(
        parsed.toLocaleString("id-ID", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      );
    } else {
      setDisplayValue("");
    }
  };

  const handleKeyDown = (e) => {
    if (
      [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
        "Enter",
      ].includes(e.key)
    )
      return;

    if (/^\d$/.test(e.key)) return;

    if (e.key === "," || e.key === ".") {
      if (!displayValue.includes(",") && !displayValue.includes(".")) return;
    }

    if (e.key === "-") {
      if (e.target.selectionStart === 0) return;
    }

    e.preventDefault();
  };

  return (
    <input
      type="text"
      value={displayValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      className={className}
      {...props}
    />
  );
};

const OperationalOutputDetail = ({}) => {
  const [, forceUpdate] = useState(0);
  const [berthingActivity, setBerthingActivity] = useState({});

  const jobRequest = useSelector(addJobRequestTransaksiSelector);
  const kendaraan = useSelector(kendaraanSelector);
  const jetty = useSelector(jettySelector);
  const oum = useSelector(OumSelector);
  const kemasan = useSelector(kemasanSelector);
  const labour = useSelector(labourSelector);
  const room = useSelector(roomSelector);
  const quatation = useSelector(quatationOperasionalSelector);
  const typeOfCloth = useSelector(typeOfClothingSelector);
  const locationUsed = useSelector(gudangSelector);

  const equipment = useSelector(kendaraanSelector);
  const feul = useSelector(fuelSelector);
  const distention = useSelector(distentionSelector);
  const [SatuanMeals, setSatuannMeals] = useState([]);

  let initialState = {
    PermitToWork: "",
    Status: "",
    QuatationNo: "",
    SPKNo: "",
    Priority: "",
    KlienID: "",
    StatusKet: "",
    Activity: [],
  };

  const param = useLocation();

  const validations = [
    ({ QuatationNo }) =>
      isRequired(QuatationNo) || { QuatationNo: "Nomor Quatation wajib diisi" },
    ({ SPKNo }) => isRequired(SPKNo) || { SPKNo: "Nomor SPK wajib diisi" },
    ({ Priority }) =>
      isRequired(Priority) || { Priority: "Priority wajib diisi" },
    ({ KlienID }) => isRequired(KlienID) || { KlienID: "ID Klien wajib diisi" },
  ];

  const {
    values,
    errors,
    touched,
    changeHandler,
    editHandler,
    changeHandlerTimeoum,
    editEquipment,
    editDetail,
    editLabour,
    changeHandlerTimeoumWSM,
    changeHandlerCargodoring,
    editTrucksEntry,
    changeHandlerActivity,
  } = useForm(initialState, validations);

  const [buttonTouched, setButtonTouched] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [Tanggal, setTanggal] = useState("");
  const [TanggalIncoming, setTanggalIncoming] = useState("");
  const [isValidTanggal, setIsValidTanggal] = useState(true);
  const [isValidTanggalIncoming, setIsValidTanggalIncoming] = useState(true);
  const [firstLoading, setFirstLoading] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [selector, setSelector] = useState([]);
  const [selectorRoom, setSelectorRoom] = useState([]);
  const limbah = useSelector(limbahSelector);
  const [selectorLimbah, setSelectorLimbah] = useState([]);
  const [selectorLimbah2, setSelectorLimbah2] = useState([]);
  const [selectorLocationUsed, setSelectorLocationUsed] = useState([]);
  const [selectorEquipment, setSelectorEquipment] = useState([]);
  const [selectorLabour, setSelectorLabour] = useState([]);
  const [selectorTrucks, setSelectorTrucks] = useState([]);
  const [checkedState, setCheckedState] = useState(false);
  const [modalShippingManifest, setModalShippingManifest] = useState(false);
  const [materialSupply, setMaterialSupply] = useState([]);
  const [AreaRental, setAreaRental] = useState([]);
  const [OumListener, setOumListener] = useState([]);

  const Kelompok = [
    { value: "1", label: "Heavy Equipment" },
    { value: "2", label: "Lifting Rigging Equipment" },
    { value: "3", label: "Cargo Carrying Unit" },
  ];
  const detailSevendoring = {
    Material: "",
    Package: "",
    Loading: "",
    Unloading: "",
    Remarks: "",
    Total: "",
    UomGeneral: "",
    UomLoading: "",
    UomUnloading: "",
    StartTime: "",
    EndTime: "",
  };

  const detailServices = {
    form1: "",
    form2: "",
    form3: "",
    form4: "",
    form5: "",
    form6: "",
    form7: "",
    form8: "",
    form9: "",
    UoM: "",
    date1: new Date(),
    date2: new Date(),
  };

  const detailVeselBerhing = {
    FinishTime: new Date(),
    FinishTimeSub: new Date(),
    Remaks: "",
    Remaksbot: "",
    StartTime: new Date(),
    StartTimeSub: new Date(),
    TotalHour: "",
    Manifest: "",
    Jetty: "",
  };

  function handleInsertJR() {
    const tempdata = values.Activity.map((activity) => ({
      ...activity,

      DetailActivity:
        activity.DetailActivity?.map((da) => ({
          ...da,
          Detail: da.Detail?.map((d) => normalizeDetail(d)) || [],
        })) || [],

      Detail: activity.Detail?.map((d) => normalizeDetail(d)) || [],
    }));

    const sendArray = {
      Equipment: values.Equipment ?? [],
      Labour: values.Labour ?? [],
      TruckEntry: values.TrucksEntry ?? [],
      Activity: tempdata,
      JRID: jobRequest.dataDetail.JRID,
    };

    dispatch(updateActivity(sendArray))
      .unwrap()
      .then(() => {
        alert("✅ Data berhasil disimpan");
      })
      .catch((err) => {
        alert("❌ Gagal menyimpan data");
        console.error(err);
      });
  }

  useEffect(() => {
    dispatch(getMinKendaraan({ search: "" }));
    dispatch(getMinJetty({ search: "" }));
    dispatch(getMinOum({ search: "" }));
    dispatch(getMinKemasan({ search: "" }));
    dispatch(getMinLabour({ search: "" }));
    dispatch(getMinRoom({ search: "" }));
    dispatch(getMinLimbah({ search: "" }));
    dispatch(getMinTypeOfClothing({ search: "" }));
    dispatch(getMinGudang({ search: "" }));
    dispatch(getMinKendaraan({ search: "" }));
    dispatch(getMinFuel({ search: "" }));
    dispatch(getMinDistention({ search: "" }));
    dispatch(getJobRequestDetailActivity({ JRID: param.state.JRID }));
  }, []);

  function diff_minutes(dt2, dt1) {
    dt2 = new Date(dt2);
    dt1 = new Date(dt1);
    if (dt2 && dt1) {
      let start = moment(dt2); // some random moment in time (in ms)
      let end = moment(dt1);
      let diff = "";
      if (dt2 < dt1) {
        diff = end.diff(start);
        let result = moment.utc(diff).format("D");
        let resultHour = moment.utc(diff).format("H");
        let resultMinuts = moment.utc(diff).format("m");
        // resultMinuts -= 1
        if (resultMinuts < 10) {
          resultMinuts = "0" + resultMinuts;
        }
        if (resultHour < 10) {
          resultHour = "0" + resultHour;
        }

        if (result === 0) {
          return resultHour + ":" + resultMinuts;
        } else {
          return (
            result + " Days and " + resultHour + ":" + resultMinuts + " Hour"
          );
        }
      } else {
        if (dt2.toDateString() === dt1.toDateString()) {
          return "1 days";
        } else {
          return "Start must be less than end";
        }
      }
      // let f = moment.utc(diff).format("HH:mm");
      // var duration = moment.duration(end.diff(start));
    }
  }
  const diff_Hour = (start, end) => {
    if (!start || !end) return 0;

    const startTime = new Date(start).getTime();
    const endTime = new Date(end).getTime();

    if (endTime <= startTime) return 0;

    const diffMs = endTime - startTime;
    return diffMs / (1000 * 60 * 60); // hasil JAM (desimal)
  };
  function diff_Hours(dt2, dt1) {
    dt2 = new Date(dt2);
    dt1 = new Date(dt1);
    if (dt2 && dt1) {
      let start = moment(dt2); // some random moment in time (in ms)
      let end = moment(dt1);
      let diff = "";
      if (dt2 < dt1) {
        diff = end.diff(start);
        let result = moment.utc(diff).format("D");
        let resultHour = moment.utc(diff).format("H");
        let resultMinuts = moment.utc(diff).format("m");
        // resultMinuts -= 1
        if (resultMinuts < 10) {
          resultMinuts = "0" + resultMinuts;
        }
        if (resultHour < 10) {
          resultHour = "0" + resultHour;
        }

        if (result === 0) {
          return result + " Days";
        } else {
          return result + " Days";
        }
      } else {
        if (dt2.toDateString() === dt1.toDateString()) {
          return "1 days";
        } else {
          return "Start must be less than end";
        }
      }
      // let f = moment.utc(diff).format("HH:mm");
      // var duration = moment.duration(end.diff(start));
    }
  }
  function diff_Day(dateStart, dateEnd) {
    if (!dateStart || !dateEnd) return 0;

    const start = moment(dateStart).startOf("day");
    const end = moment(dateEnd).startOf("day");

    if (end.isBefore(start)) return 0;

    const diffDays = end.diff(start, "days");

    // 🔥 aturan:
    // 0 hari  -> 1
    // > 1 hari -> diff + 1
    return diffDays >= 1 ? diffDays + 1 : 1;
  }

  function getMinutes(dt2, dt1, kelompokKendaraan, qty) {
    dt2 = new Date(dt2);
    dt1 = new Date(dt1);
    if (
      kelompokKendaraan &&
      kelompokKendaraan !== "" &&
      kelompokKendaraan !== undefined
    ) {
      kelompokKendaraan = kelompokKendaraan.toLowerCase();
      if (kelompokKendaraan == "trip") {
        return qty;
      }
      // Set the two dates
      let diffMs = Math.abs(dt2.getTime() - dt1.getTime());
      let diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
      if (kelompokKendaraan.includes("hour")) {
        diffHrs += 1;
        return diffHrs * qty;
      } else {
        let days = Math.floor(diffHrs / 24);
        if (diffHrs % 24 > 0) {
          days += 1;
        }
        // if(days !== 0 )days+=1

        return days * qty;
      }
    } else {
      return 0;
    }
  }

  function handleInsertEquipment() {
    let tempdata = JSON.parse(JSON.stringify(values));
    const Equipment = {
      Unit: "",
      UnitNumber: "",
      StartTime: new Date("July 4 1776 00:00"),
      FinishTime: new Date("July 4 1776 00:00"),
      TotalHour: "00:00",
      HourMeter: "",
      TotalHourMeter: "",
      Remarks: "",
    };
    if (!tempdata.Equipment) {
      tempdata.Equipment = [];
    }
    tempdata.Equipment.push(Equipment);
    editEquipment(tempdata.Equipment);
  }

  function handleInsertLabour() {
    let tempdata = JSON.parse(JSON.stringify(values));
    const Labour = {
      LabourDesc: "",
      StartTime: new Date("July 4 1776 00:00"),
      FinishTime: new Date("July 4 1776 00:00"),
      TotalHour: "00:00",
      TotalManPower: "",
      Remarks: "",
    };
    if (!tempdata.Labour) {
      tempdata.Labour = [];
    }
    tempdata.Labour.push(Labour);
    editLabour(tempdata.Labour);
  }

  function handleInsertTrucksEntry() {
    let tempdata = JSON.parse(JSON.stringify(values));
    const TrucksEntry = {
      MaterialDesc: "",
      Transporter: "",
      UnitNumber: "",
      EntryDate: new Date(),
      ExitDate: new Date(),
      TotalHour: "00:00",
      Remarks: "",
    };
    if (!tempdata.TrucksEntry) {
      tempdata.TrucksEntry = [];
    }
    tempdata.TrucksEntry.push(TrucksEntry);
    editTrucksEntry(tempdata.TrucksEntry);
  }

  function inputGenerator(name, dex, subdex, val, type, i, subs) {
    type = typeof type !== "undefined" ? type : "text";
    let tempdata = JSON.parse(JSON.stringify(values.Activity));
    let data = "";
    if (subdex !== -1) {
      data = tempdata[dex].DetailActivity[subdex]["Detail"][i];
    } else {
      data = tempdata[dex]["Detail"][i];
    }
    if (type === "text") {
      return (
        <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <input
            value={val}
            name={name}
            onChange={(e) => changeHandlerCargodoring(e, dex, subdex, i)}
            className={
              "appearance-none block w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
            }
            type={type}
          />
        </th>
      );
    } else if (type === "number") {
      return (
        <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <NumberInputField
            value={val}
            name={name}
            onChange={(e) => changeHandlerCargodoring(e, dex, subdex, i)}
            className={
              "appearance-none block w-40 text-gray-700 py-2 px-2 border border-gray-200 rounded leading-tight outline-none bg-white border-gray-500"
            }
          />
        </th>
      );
    } else if (type === "numbersatu") {
      return (
        <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <NumberFormat
            onValueChange={(e) =>
              changeHandlerCargodoring(e.value, dex, subdex, i)
            }
            name={name}
            value={val}
            className={
              "appearance-none block w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
            }
            // isAllowed={(values) => {
            //   const { floatValue } = values;
            //   return floatValue >= 5 && floatValue <= 10000;
            // }}
          />
        </th>
      );
    } else if (type === "Oum") {
      if (parseInt(subs) >= 5) {
        subs = "5";
      }
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <Select
            value={oum.minData.filter(({ value }) => value === val)}
            name={name}
            menuPortalTarget={document.body}
            className=" w-40 "
            onChange={(text) =>
              changeHandlerTimeoum(name, text.value, dex, subdex, i)
            }
            options={oum.minData.filter(
              ({ CategoryID }) => CategoryID === subs,
            )}
          />
        </td>
      );
    } else if (type === "OumRental") {
      if (parseInt(subs) >= 5) {
        subs = "5";
      }
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <Select
            value={oum.minData.filter(({ value }) => value === val)}
            name={name}
            menuPortalTarget={document.body}
            className=" w-40 "
            onChange={(text) => {
              changeHandlerTimeoum(name, text.value, dex, subdex, i);
              let tempOumListener = OumListener;
              tempOumListener[i] = text.label;
              setOumListener(tempOumListener);
            }}
            options={oum.minData.filter(
              ({ CategoryID }) => CategoryID === subs,
            )}
          />
        </td>
      );
    } else if (type === "OumMeals") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <Select
            value={oum.minData.filter(({ value }) => value === val)}
            name={name}
            menuPortalTarget={document.body}
            className=" w-40 "
            onChange={(text) =>
              changeHandlerTimeoum(name, text.value, dex, subdex, i)
            }
            options={oum.minData.filter(({ value }) =>
              SatuanMeals.includes(value),
            )}
          />
        </td>
      );
    } else if (type === "Feul") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <Select
            value={feul.minData.filter(({ value }) => value === val)}
            name={name}
            menuPortalTarget={document.body}
            className=" w-40 "
            onChange={(text) =>
              changeHandlerTimeoum(name, text.value, dex, subdex, i)
            }
            options={feul.minData}
          />
        </td>
      );
    } else if (type === "Limbah1") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <Select
            value={selectorLimbah.filter(({ value }) => value === val)}
            name={name}
            menuPortalTarget={document.body}
            className=" w-40 "
            onChange={(text) =>
              changeHandlerTimeoum(name, text.value, dex, subdex, i)
            }
            options={selectorLimbah}
          />
        </td>
      );
    } else if (type === "LocationUsed") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <Select
            value={selectorLocationUsed.filter(({ value }) => value === val)}
            name={name}
            menuPortalTarget={document.body}
            className=" w-40 "
            onChange={(text) =>
              changeHandlerTimeoum(name, text.value, dex, subdex, i)
            }
            options={selectorLocationUsed}
          />
        </td>
      );
    } else if (type === "Limbah2") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <Select
            value={selectorLimbah2.filter(({ value }) => value === val)}
            name={name}
            menuPortalTarget={document.body}
            className=" w-40 "
            onChange={(text) =>
              changeHandlerTimeoum(name, text.value, dex, subdex, i)
            }
            options={selectorLimbah2}
          />
        </td>
      );
    } else if (type === "Distenation") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <Select
            value={distention.minData.filter(({ value }) => value === val)}
            name={name}
            menuPortalTarget={document.body}
            className=" w-40 "
            onChange={(text) =>
              changeHandlerTimeoum(name, text.value, dex, subdex, i)
            }
            options={distention.minData}
          />
        </td>
      );
    } else if (type === "Selector") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <Select
            value={selector.filter(({ value }) => value === val)}
            name={name}
            menuPortalTarget={document.body}
            className=" w-40 "
            onChange={(text) =>
              changeHandlerTimeoum(name, text.value, dex, subdex, i)
            }
            options={selector.filter(({ category }) => category === subs)}
          />
        </td>
      );
    } else if (type === "SelectorWSM") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <Select
            value={selector.filter(({ value }) => value === val)}
            name={name}
            menuPortalTarget={document.body}
            className=" w-40 "
            onChange={(text) => {
              changeHandlerTimeoumWSM(
                name,
                text.value,
                dex,
                subdex,
                i,
                text.categoryRental,
              );
              // changeHandlerTimeoum("form8", text.categoryRental, dex, subdex, i);
            }}
            options={selector.filter(({ category }) => category === subs)}
          />
        </td>
      );
    } else if (type === "Jetty") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <Select
            value={jetty.minData.filter(({ value }) => value === val)}
            name={name}
            menuPortalTarget={document.body}
            className=" w-40 "
            onChange={(text) =>
              changeHandlerTimeoum(name, text.value, dex, subdex, i)
            }
            options={jetty.minData}
          />
        </td>
      );
    } else if (type === "kelompokKendaraan") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <Select
            value={Kelompok.filter(({ value }) => value === val)}
            name={name}
            menuPortalTarget={document.body}
            className=" w-40 "
            onChange={(text) =>
              changeHandlerTimeoum(name, text.value, dex, subdex, i)
            }
            options={Kelompok}
          />
        </td>
      );
    } else if (type === "PackagePort") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <Select
            value={kemasan.minData.filter(({ value }) => value === val)}
            name={name}
            menuPortalTarget={document.body}
            className=" w-40 "
            onChange={(text) =>
              changeHandlerTimeoum(name, text.value, dex, subdex, i)
            }
            options={kemasan.minData.filter(({ category }) => category === "1")}
          />
        </td>
      );
    } else if (type === "OperationType") {
      const operationOptions = [
        { value: "Loading", label: "Loading" },
        { value: "Unloading", label: "Unloading" },
        { value: "Both", label: "Both (Loading & Unloading)" },
      ];
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <Select
            value={operationOptions.filter(({ value }) => value === val)}
            name={name}
            menuPortalTarget={document.body}
            className=" w-40 "
            onChange={(text) =>
              changeHandlerTimeoum(name, text?.value || "", dex, subdex, i)
            }
            options={operationOptions}
          />
        </td>
      );
    } else if (type === "SelectorKendaraan") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <Select
            value={AreaRental.filter(({ value }) => value === val)}
            name={name}
            menuPortalTarget={document.body}
            className=" w-40 "
            onChange={(text) =>
              changeHandlerTimeoum(name, text.value, dex, subdex, i)
            }
            options={AreaRental.filter(
              ({ category }) => category === data["form1"],
            )}
          />
        </td>
      );
    } else if (type === "MaterialSupplySelector") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <Select
            value={materialSupply.filter(({ value }) => value === val)}
            name={name}
            menuPortalTarget={document.body}
            className=" w-40 "
            onChange={(text) =>
              changeHandlerTimeoum(name, text.value, dex, subdex, i)
            }
            options={materialSupply}
          />
        </td>
      );
    } else if (type === "TypeOfCloth") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <Select
            value={typeOfCloth.minData.filter(({ value }) => value === val)}
            name={name}
            menuPortalTarget={document.body}
            className=" w-40 "
            onChange={(text) =>
              changeHandlerTimeoum(name, text.value, dex, subdex, i)
            }
            options={typeOfCloth.minData}
          />
        </td>
      );
    } else if (type === "PackageWSM") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <Select
            value={kemasan.minData.filter(({ value }) => value === val)}
            name={name}
            menuPortalTarget={document.body}
            className=" w-40 "
            onChange={(text) =>
              changeHandlerTimeoum(name, text.value, dex, subdex, i)
            }
            options={kemasan.minData.filter(({ category }) => category === "2")}
          />
        </td>
      );
    } else if (type === "equipment") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <Select
            value={equipment.filter(({ value }) => value === val)}
            name={name}
            menuPortalTarget={document.body}
            className=" w-40 "
            onChange={(text) =>
              changeHandlerTimeoum(name, text.value, dex, subdex, i)
            }
            options={equipment}
          />
        </td>
      );
    } else if (type === "date") {
      if (!val || isNaN(new Date(val).getTime())) {
        val = new Date();
      }
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <DatePicker
            dateFormat="dd/MMMM/yyyy"
            selected={new Date(val)}
            className={
              "appearance-none block text-center w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
            }
            onChange={(text) =>
              changeHandlerTimeoum(name, text, dex, subdex, i)
            }
          />
        </td>
      );
    } else if (type === "time") {
      if (!val || isNaN(new Date(val).getTime())) {
        val = new Date();
      }
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <DatePicker
            showTimeSelectOnly
            showTimeInput
            showTimeSelect
            dateFormat="HH:mm"
            timeFormat={"HH:mm"}
            selected={new Date(val)}
            className={
              "appearance-none block text-center w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
            }
            onChange={(text) =>
              changeHandlerTimeoum(name, text, dex, subdex, i)
            }
          />
        </td>
      );
    } else if (type === "button") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <button
            onClick={() => deleteActivity(dex, i, subdex)}
            className="flex flex-row mt-1 items-center bg-red hover:bg-red-100 text-red-800 font-semibold py-1 px-4 border border-red-400 rounded shadow"
          >
            <BiTrash className="text-xl text-red-800" />
          </button>
        </td>
      );
    } else if (type === "time") {
      if (val === "") {
        val = new Date();
      }
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <DatePicker
            showTimeSelectOnly
            showTimeInput
            dateFormat="HH:mm"
            selected={new Date(val)}
            className={
              "appearance-none block text-center w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
            }
            onChange={(text) =>
              changeHandlerTimeoum(name, text, dex, subdex, i)
            }
          />
        </td>
      );
    } else if (type === "totalTime") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          {diff_minutes(data["date1"], data["date2"])}
        </td>
      );
    } else if (type === "totalDays") {
      const days = diff_Day(data["date1"], data["date2"]);
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          {days}
        </td>
      );
    } else if (type === "totalVehicle") {
      const days = diff_Day(data["date1"], data["date2"]);
      const qty = Number(data.form3) || 0;
      const total = days * qty;
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          {total.toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </td>
      );
    } else if (type === "totalDays2") {
      const totalDays = diff_Day(data.date1, data.date2);

      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          {totalDays}
        </td>
      );
    } else if (type === "totalDays2") {
      const totalDays = diff_Day(data.date1, data.date2);

      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          {totalDays}
        </td>
      );
    } else if (type === "TMeal") {
      const qty = Number(data.form6 || 0);

      // Total Meal langsung dari Qty, tidak terpengaruh tanggal
      const totalMeal = qty;

      return (
        <td className="border-b border-gray-200 text-right px-2 py-1">
          {totalMeal > 0 ? totalMeal.toLocaleString("id-ID") : "0"}
        </td>
      );
    } else if (type === "numbering") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-center">
          {i + 1}
        </td>
      );
    } // Di dalam inputGenerator function, perbaiki case untuk "SBerthing":
    else if (type === "SBerthing") {
      const rowKey = `${dex}-${subdex}-${i}-${name}`;
      const currentValue = data[name] || "";

      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <select
            value={currentValue}
            onChange={(e) => {
              const val = e.target.value;

              // Update langsung ke data
              if (subdex === -1) {
                tempdata[dex].Detail[i][name] = val;
              } else {
                tempdata[dex].DetailActivity[subdex]["Detail"][i][name] = val;
              }

              // Update state
              changeHandlerActivity(tempdata);

              // Juga update berthingActivity state untuk tracking
              setBerthingActivity((prev) => ({
                ...prev,
                [rowKey]: val,
              }));
            }}
            className="appearance-none block w-40 text-gray-700 py-2 px-2 border border-gray-200 rounded leading-tight outline-none bg-white border-gray-500"
          >
            <option value="">-- Pilih Aktivitas --</option>
            <option value="Standby">Standby</option>
            <option value="Loading/Unloading">Loading/Unloading</option>
          </select>
        </td>
      );
    } else if (type === "TBerthing") {
      const rowKey = `${dex}-${subdex}-${i}-form5`; // key untuk form5 (SBerthing)
      const activity = data["form5"] ? data["form5"].toLowerCase() : "";

      let hours = 0;

      if (data["date1"] && data["date2"]) {
        const raw = diff_Hour(data["date1"], data["date2"]);
        hours = activity === "standby" ? Math.min(raw, 4) : raw;
      }

      // Format jam dengan 2 desimal
      const formattedHours = hours.toFixed(2);

      // Simpan nilai ke field form4
      if (subdex === -1) {
        tempdata[dex].Detail[i]["form4"] = formattedHours;
      } else {
        tempdata[dex].DetailActivity[subdex]["Detail"][i]["form4"] =
          formattedHours;
      }

      // Update state jika nilai berubah
      if (data["form4"] !== formattedHours) {
        changeHandlerActivity(tempdata);
      }

      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          {formattedHours}
        </td>
      );
    } else if (type === "TimeRental") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          {getMinutes(
            data["date1"],
            data["date2"],
            OumListener[i],
            data["form6"],
          )}
        </td>
        // <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
        //   {data["form6"]}
        // </td>
      );
    } else if (type === "TDimension") {
      const length = Number(data.form4 || 0);
      const wide = Number(data.form5 || 0);
      const height = Number(data.form6 || 0);

      const totalDimension = length * wide * height;

      return (
        <td className="border-b border-gray-200 align-middle text-sm px-2 py-1 text-right">
          {totalDimension
            ? Math.round(totalDimension).toLocaleString("id-ID")
            : "0"}
        </td>
      );
    } else if (type === "TArarental") {
      const length = Number(data.form4 || 0);
      const wide = Number(data.form5 || 0);
      const height = Number(data.form6 || 0);

      const quantity = Number(data.form2 || 0);

      const totalDimension = length * wide * height;
      const totalRental = totalDimension * quantity;

      return (
        <td className="border-b border-gray-200 text-right px-2 py-1">
          {totalRental ? Math.round(totalRental).toLocaleString("id-ID") : "0"}
        </td>
      );
    } else if (type === "totalHourManpower") {
      // Total Hour = range jam × range hari
      let hoursPerDay = 0;
      let diffDays = 0;

      // Hitung range jam dari date3-date4 (Working Time)
      if (data.date3 && data.date4) {
        let startH, startM, endH, endM;
        
        // Extract hours/minutes from Date objects or strings
        if (data.date3 instanceof Date) {
          startH = data.date3.getHours();
          startM = data.date3.getMinutes();
        } else if (typeof data.date3 === "string" && data.date3.includes(":")) {
          [startH, startM] = data.date3.split(":").map(Number);
        }
        
        if (data.date4 instanceof Date) {
          endH = data.date4.getHours();
          endM = data.date4.getMinutes();
        } else if (typeof data.date4 === "string" && data.date4.includes(":")) {
          [endH, endM] = data.date4.split(":").map(Number);
        }
        
        if (startH !== undefined && endH !== undefined) {
          const startMinutes = (startH || 0) * 60 + (startM || 0);
          const endMinutes = (endH || 0) * 60 + (endM || 0);
          
          if (endMinutes > startMinutes) {
            hoursPerDay = (endMinutes - startMinutes) / 60;
          }
        }
      }

      // Hitung range hari dari date1-date2 (Working Date) - inclusive
      if (data.date1 && data.date2) {
        const startDate = moment(data.date1).startOf("day");
        const endDate = moment(data.date2).startOf("day");

        if (endDate.isSameOrAfter(startDate)) {
          diffDays = endDate.diff(startDate, "days") + 1;
        }
      }

      const totalHours = hoursPerDay * diffDays;

      return (
        <td className="border-b border-gray-200 text-right px-2 py-1 text-sm">
          {totalHours > 0 ? totalHours.toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}
        </td>
      );
    } else if (type === "totalManpowerValue") {
      // Hitung Total = Total Hour (form5 manual) × Total Manpower (form2)
      const totalHours = Number(data.form5) || 0;
      const totalManpower = Number(data.form2) || 0;
      const total = totalHours * totalManpower;

      return (
        <td className="border-b border-gray-200 text-right px-2 py-1 text-sm font-semibold text-purple-700">
          {total > 0 ? total.toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}
        </td>
      );
    } else if (type === "TotalFuel") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          {data["form4"] - data["form3"]}
        </td>
      );
    } else if (type === "totalDrill") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          {Math.abs(parseInt(data["form4"]) - parseInt(data["form5"]))}
        </td>
      );
    } else if (type === "dateTime") {
      if (!val || isNaN(new Date(val).getTime())) {
        val = new Date();
      }
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <DatePicker
            showTimeInput
            showTimeSelect
            dateFormat="dd/MMMM/yyyy HH:mm"
            timeFormat={"dd/MMMM/yyyy HH:mm"}
            selected={new Date(val)}
            className={
              "appearance-none block text-center w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
            }
            onChange={(text) =>
              changeHandlerTimeoum(name, text, dex, subdex, i)
            }
          />
        </td>
      );
    }
  }

  function deleteTrucksEntry(i) {
    let tempdata = JSON.parse(JSON.stringify(values));
    tempdata.TrucksEntry.splice(i, 1);
    editTrucksEntry(tempdata.TrucksEntry);
  }

  function deleteLabour(i) {
    let tempdata = JSON.parse(JSON.stringify(values));
    tempdata.Labour.splice(i, 1);
    editLabour(tempdata.Labour);
  }

  function deleteActivity(ind, i, z) {
    let tempdata = JSON.parse(JSON.stringify(values.Activity));
    if (tempdata) {
      if (z === -1) {
        tempdata[ind].Detail.splice(i, 1);

        changeHandlerActivity(tempdata);
      } else {
        tempdata[ind].DetailActivity[z]["Detail"].splice(i, 1);
        changeHandlerActivity(tempdata);
      }
    }
  }

  function deleteEquipment(i) {
    let tempdata = JSON.parse(JSON.stringify(values));
    tempdata.Equipment.splice(i, 1);
    editEquipment(tempdata.Equipment);
  }

  const getLabelByValue = (value, obj) => {
    for (let i = 0; i < obj.length; i++) {
      if (obj[i].value === value) {
        return obj[i].label;
      }
    }
    return null; // Value not found
  };
  useEffect(() => {
    if (jobRequest.isGetDetailSuccess && !firstLoading) {
      if (!quatation.isGetSuccess && !quatation.isGetFetching)
        dispatch(
          getQuatationOperasional({
            QuatationNo: jobRequest.dataDetail.QuatationNo,
          }),
        );
      if (quatation.isGetSuccess && !firstLoading) {
        let EquipmentPicker = [];
        let LabourPicker = [];
        let Trucks = [];

        quatation.data.Equipment &&
          quatation.data.Equipment.map(({ Unit }, index) => {
            EquipmentPicker.push(Unit);
          });
        quatation.data.Labour &&
          quatation.data.Labour.map(({ Labour }, index) => {
            LabourPicker.push(Labour);
          });
        quatation.data.Truck &&
          quatation.data.Truck.map(({ Description }, index) => {
            Trucks.push({ value: Description, label: Description });
          });
        let tempdata = JSON.parse(
          JSON.stringify(jobRequest.dataDetail.Activity),
        );
        tempdata = SortingPORT_Services(tempdata);
        if (values.Activity.length === 0) {
          changeHandlerActivity(jobRequest.dataDetail.Activity);
        }
        const initValues = {
          PermitToWork: jobRequest.dataDetail.PermitToWork,
          Status: jobRequest.dataDetail.Status,
          ShippingManifest: jobRequest.dataDetail.ShippingManifest,
          ShippingManifestDetail: jobRequest.dataDetail.ShippingManifestDetail,
          NamaKlien: jobRequest.dataDetail.NamaKlien,
          IncomingDate: jobRequest.dataDetail.IncomingDate,
          QuatationNo: jobRequest.dataDetail.QuatationNo,
          SPKNo: jobRequest.dataDetail.SPKNo,
          Priority: jobRequest.dataDetail.Priority,
          KlienID: jobRequest.dataDetail.KlienID,
          StatusKet: jobRequest.dataDetail.StatusKet,
          Activity: tempdata,
          TrucksEntry: jobRequest.dataDetail.TruckEntry,
          Labour: jobRequest.dataDetail.Labour,
          Equipment: jobRequest.dataDetail.Equipment,
          RequestUnit: jobRequest.dataDetail.RequestUnit,
        };
        editHandler(initValues);
        setTanggal(
          jobRequest?.dataDetail?.Date
            ? new Date(jobRequest.dataDetail.Date)
            : new Date(),
        );
        setTanggalIncoming(
          jobRequest?.dataDetail?.IncomingDate
            ? new Date(jobRequest.dataDetail.IncomingDate)
            : new Date(),
        );
        let AllLimbah = false;
        let AllRoom = false;
        let WSMPicker = [];
        let LocationUsedPicker = [];
        let tempMaterialSupply = [];
        quatation.data.Activity.map(({ Name, DetailActivity }, index) => {
          if (
            Name === "GENERAL_SERVICE" ||
            Name === "WASTE_MANAGEMENT_SERVICES"
          ) {
            DetailActivity &&
              DetailActivity.map(
                ({ DetailUnit, Surname, Category }, SubIndex) => {
                  if (DetailUnit === "ROOM") {
                    if (Surname === "Room All") {
                      room.minData.map((data, i) => {
                        if (data.label !== "All") {
                          let tempArray = {
                            value: data.label,
                            category: "7",
                            label: data.label,
                          };
                          setSelector((selector) => [tempArray, ...selector]);
                        }
                      });
                    } else {
                      let tempArray = {
                        value: Surname,
                        category: "7",
                        label: Surname,
                      };
                      setSelector((selector) => [tempArray, ...selector]);
                    }
                  } else if (DetailUnit === "MEALS") {
                    let satuanmeals = SatuanMeals;
                    let tempsatuan = DetailActivity[SubIndex]["SatuanID"];
                    if (!satuanmeals.includes(tempsatuan)) {
                      satuanmeals.push(tempsatuan);
                    }
                    setSatuannMeals(satuanmeals);
                    let tempArray = {
                      value: Surname,
                      category: "8",
                      label: Surname,
                    };
                    setSelector((selector) => [tempArray, ...selector]);
                  } else if (DetailUnit === "WOODEN") {
                    LocationUsedPicker.push(Surname);
                    let tempArray = {
                      value: Surname,
                      category: "9",
                      label: Surname,
                    };
                    setSelector((selector) => [tempArray, ...selector]);
                  } else if (DetailUnit === "Drill") {
                    let tempArray = {
                      value: Surname,
                      category: "10",
                      label: Surname,
                    };
                    setSelector((selector) => [tempArray, ...selector]);
                  } else if (DetailUnit === "Others") {
                    tempMaterialSupply.push(Category);
                    let tempArray2 = { value: Category, label: Category };
                    setMaterialSupply((selector) => [tempArray2, ...selector]);
                    let tempArray = {
                      value: Surname,
                      category: "11",
                      label: Surname,
                    };
                    setSelector((selector) => [tempArray, ...selector]);
                  } else if (DetailUnit === "Vehicle") {
                    let tempArray = {
                      value: Surname,
                      category: "12",
                      label: Surname,
                    };
                    setSelector((selector) => [tempArray, ...selector]);
                  } else if (Name === "WASTE_MANAGEMENT_SERVICES") {
                    if (DetailUnit === "0") {
                      AllLimbah = true;
                    }
                    WSMPicker.push(DetailUnit);
                  }
                  if (DetailActivity[SubIndex]["Name"] === "Clearance Doc") {
                    let tempArray = {
                      value: Category,
                      category: "15",
                      label: Category,
                    };
                    setSelector((selector) => [tempArray, ...selector]);
                  }

                  if (DetailActivity[SubIndex]["Name"] === "Material Supply") {
                    let tempArray = {
                      value: Category,
                      category: "16",
                      label: Category,
                    };
                    setSelector((selector) => [tempArray, ...selector]);
                  }
                },
              );
          }
          if (Name === "AREA_RENTAL") {
            DetailActivity &&
              DetailActivity.map(
                ({ DetailUnit, Surname, Category }, SubIndex) => {
                  let tempArray = {
                    value: Surname,
                    category: "4",
                    label: Surname,
                  };
                  setSelector((selector) => [tempArray, ...selector]);
                },
              );
          }
          if (Name === "RENTAL") {
            DetailActivity &&
              DetailActivity.map(({ Category, Surname }, SubIndex) => {
                let tempArray = {
                  value: Surname,
                  category: Category,
                  label: Surname,
                };
                let temp = AreaRental;
                temp.push(tempArray);
                setAreaRental(temp);
              });
          }
        });
        let res = limbah.minDataKode.filter((e) => WSMPicker.includes(e.value));
        let res2 = limbah.minData.filter((e) => WSMPicker.includes(e.value));
        const res3 = locationUsed.minData.filter((e) =>
          LocationUsedPicker.includes(e.categoryName),
        );
        const res4 = kendaraan.minData.filter((e) =>
          EquipmentPicker.includes(e.value),
        );
        // const res5 = labour.minData.filter((e) =>
        //   LabourPicker.includes(e.value)
        // );
        let res5;
        if (LabourPicker && LabourPicker.length > 0) {
          res5 = labour.minData.filter((e) => LabourPicker.includes(e.value));
        } else {
          res5 = labour.minData; // Jika LabourPicker kosong, tampilkan semua
        }
        setSelectorLabour(res5);
        if (AllLimbah)
          res = limbah.minDataKode.filter(
            (e) => !WSMPicker.includes(e.value) && e.label !== "-",
          );
        if (AllLimbah)
          res2 = limbah.minData.filter((e) => !WSMPicker.includes(e.value));

        setSelectorLimbah(res);
        setSelectorLimbah2(res2);
        setSelectorLocationUsed(res3);
        setSelectorEquipment(res4);
        setSelectorLabour(res5);
        setSelectorTrucks(Trucks);

        jobRequest.dataDetail.Activity.map(
          ({ Name, DetailActivity, Checked, Detail }, index) => {
            let subs = "1";
            if (Name === "PORT_SERVICES") {
              if (Checked) {
                setCheckedState(true);
              }
            }
            if (Name === "GENERAL_SERVICE") {
              subs = "5";
            }
            if (Name === "MANPOWER") {
              subs = "6";
            }

            if (Name === "RENTAL") {
              let oumlistener = OumListener;
              Detail &&
                Detail.map(({ form4 }, i) => {
                  oumlistener[i] = getLabelByValue(form4, oum.minData);
                });
              setOumListener(oumlistener);
            }

            if (
              Name !== "WASTE_MANAGEMENT_SERVICES" ||
              Name !== "AREA_RENTAL"
            ) {
              DetailActivity &&
                DetailActivity.map((keyName, i) => {
                  if (Name !== "GENERAL_SERVICE") {
                    let tempArray = {
                      value: keyName["Surname"],
                      category: subs,
                      label: keyName["Surname"],
                    };
                    setSelector((selector) => [tempArray, ...selector]);
                  }
                });
            }
          },
        );
        // if (jobRequest.dataDetail.Selector) {
        //     setSelector(selector => [...jobRequest.dataDetail.Selector, ...selector])
        // }
        dispatch(changeResponseSucess());
        setFirstLoading(true);
      }
    }
    if (jobRequest.isUpdateActivitySuccess) {
      dispatch(changeResponseSucess());

      setFirstLoading(true);
      navigate("/operasional-activity");
    }
  });

  function handleInsertServices(index, subIndex, Surname, Name) {
    let tempdata = JSON.parse(JSON.stringify(values.Activity));
    let tempDetail = detailServices;
    if (Name === "Vessel_Service") {
      tempDetail.form9 = Surname;
      tempDetail.form5 = ""; // Activity Type (Standby/Loading-Unloading)
      tempDetail.form4 = 0; // Total Hours
    }
    if (subIndex === -1) {
      if (tempdata[index].Detail !== null) {
        tempdata[index].Detail = [...tempdata[index].Detail, tempDetail];
      } else {
        tempdata[index].Detail = [tempDetail];
      }
    } else {
      if (tempdata[index].DetailActivity[subIndex]["Detail"] !== null) {
        tempdata[index].DetailActivity[subIndex]["Detail"] = [
          ...tempdata[index].DetailActivity[subIndex]["Detail"],
          tempDetail,
        ];
      } else {
        tempdata[index].DetailActivity[subIndex]["Detail"] = [tempDetail];
      }
    }

    changeHandlerActivity(tempdata);
  }

  const GMArray = [
    { id: "Accomodation/Room", DetailUnit: "ROOM" },
    { id: "MEALS", DetailUnit: "MEALS" },
    { id: "Laundry", DetailUnit: "LAUNDRY" },
    { id: "Wooden Dunnage & Pallet Wraping", DetailUnit: "WOODEN" },
    { id: "Drill & Fresh Water", DetailUnit: "Drill" },
    { id: "Fuel", DetailUnit: "Fuel" },
    { id: "Vehicle Rental", DetailUnit: "Vehicle" },
    { id: "Clearance Doc", DetailUnit: "Clearance Doc" },
    { id: "Material Supply", DetailUnit: "Material_Supply" },
  ];
  let user = JSON.parse(localStorage.getItem("user"));

  // Hanya dipakai tombol "Download Supporting File JR" (Shipping Manifest).
  // File baru ada di service file_upload, file lama di ./data/pdf backend —
  // helper bersama yang memilih sumbernya.
  const getDataFromURL = (url) => openSupportingFile(url);
  if (!firstLoading) {
    return <Loading />;
  } else {
    return (
      <>
        <div className="md:ml-64">
          <div
            style={{ background: Colors.white }}
            className="pt-14 pb-16 px-3 md:px-8 h-auto"
          >
            <div className="container mx-auto max-w-full">
              <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
            </div>
          </div>
          <div className="px-3 md:px-8 h-auto -mt-32">
            <div className="flex w-full justify-end p-4 flex-col sm:flex-row pt-4">
              <button
                onClick={() => navigate("/operasional-activity")}
                className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
              >
                <BiArrowBack className="text-xl text-gray-800 pr-2" />
                Kembali
              </button>

              <button
                onClick={() => handleInsertJR()}
                className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
              >
                Simpan
              </button>
            </div>
            <div className="flex flex-row">
              <div className="px-4 py-4 flex-1">
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Nomor Quatation
                    </label>
                    <div className="inline-block relative w-full">
                      <input
                        disabled
                        value={values.QuatationNo}
                        onChange={changeHandler}
                        name="QuatationNo"
                        className={
                          (touched.QuatationNo || buttonTouched) &&
                          errors.QuatationNo
                            ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                            : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                        }
                        type="text"
                      />
                    </div>
                    {(touched.QuatationNo || buttonTouched) &&
                      errors.QuatationNo && (
                        <p className="text-red-500 text-xs italic">
                          {errors.QuatationNo}
                        </p>
                      )}
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Nomor SPK
                    </label>
                    <input
                      disabled
                      value={values.SPKNo}
                      onChange={changeHandler}
                      name="SPKNo"
                      className={
                        (touched.SPKNo || buttonTouched) && errors.SPKNo
                          ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                      type="text"
                    />
                    {(touched.SPKNo || buttonTouched) && errors.SPKNo && (
                      <p className="text-red-500 text-xs italic">
                        {errors.SPKNo}
                      </p>
                    )}
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Priority
                    </label>
                    <div className="inline-block relative w-full  ">
                      <input
                        disabled
                        value={values.Priority}
                        name="Priority"
                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Request Unit
                    </label>
                    <div className="inline-block relative w-full  ">
                      <input
                        disabled
                        value={values.RequestUnit}
                        name="Priority"
                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-4 flex-1">
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Client
                    </label>
                    <input
                      disabled
                      value={values.NamaKlien}
                      onChange={changeHandler}
                      name="KlienID"
                      className={
                        (touched.NamaKlien || buttonTouched) && errors.NamaKlien
                          ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                      type="text"
                    />
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3">
                  <div className="w-full px-3 mb-6">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Tanggal
                    </label>
                    <DatePicker
                      className={
                        "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                      disabled
                      selected={Tanggal}
                    />
                    {!isValidTanggal && (
                      <p className="text-red-500 text-xs italic">
                        Tanggal pengajuan wajib diisi
                      </p>
                    )}
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Shipping Manifest
                    </label>
                    <div className="inline-block relative w-full">
                      <div
                        disabled
                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                        onClick={() =>
                          setModalShippingManifest(!modalShippingManifest)
                        }
                        type="text"
                      >
                        {values.ShippingManifest}
                      </div>
                      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg
                          className="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 491.52 491.52"
                        >
                          <ellipse
                            cx="158.537"
                            cy="158.536"
                            rx="129.777"
                            ry="129.777"
                          />
                          <path
                            d="M98.081,234.62c-43.316-43.315-43.882-112.979-1.264-155.595
	c9.509-9.511,20.41-16.745,32.021-21.96c-16.497,4.812-32.056,13.702-45.064,26.71c-41.288,41.289-41.289,108.231,0,149.521
	c18.282,18.281,41.596,28.431,65.483,30.523C130.561,258.986,112.79,249.33,98.081,234.62z"
                          />
                          <path
                            d="M270.636,46.433c-61.912-61.912-162.291-61.911-224.202,0.001s-61.912,162.291-0.001,224.202
	c57.054,57.054,146.703,61.394,208.884,13.294l14.18,14.182l28.615-28.613l-14.182-14.182
	C332.029,193.137,327.69,103.487,270.636,46.433z M250.301,250.302c-50.681,50.681-132.852,50.681-183.534,0
	c-50.68-50.681-50.68-132.852,0.002-183.533s132.85-50.681,183.531,0C300.982,117.45,300.982,199.621,250.301,250.302z"
                          />
                          <path
                            d="M305.823,258.865l-46.959,46.958c-2.669,2.67-2.669,6.996,0,9.665l174.339,174.338
	c12.132,12.133,68.755-44.49,56.623-56.623L315.488,258.865C312.819,256.196,308.493,256.196,305.823,258.865z"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Incoming Date / Time
                    </label>
                    <DatePicker
                      disabled
                      className={
                        !isValidTanggalIncoming
                          ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                      selected={TanggalIncoming}
                      onChange={(date) => {
                        setTanggalIncoming(date);
                        setIsValidTanggalIncoming(true);
                      }}
                    />
                    {!isValidTanggalIncoming && (
                      <p className="text-red-500 text-xs italic">
                        Tanggal Incoming wajib diisi
                      </p>
                    )}
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Permit to Work No *
                    </label>
                    <input
                      value={values.PermitToWork}
                      onChange={changeHandler}
                      name="PermitToWork"
                      className={
                        (touched.PermitToWork || buttonTouched) &&
                        errors.PermitToWork
                          ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                      type="text"
                    />
                    {(touched.PermitToWork || buttonTouched) &&
                      errors.PermitToWork && (
                        <p className="text-red-500 text-xs italic">
                          {errors.PermitToWork}
                        </p>
                      )}
                  </div>
                </div>
              </div>
            </div>
            <div className="p-4">
              <label className="block uppercase tracking-wide text-gray-700 text-l font-bold mb-2">
                Detail Activity
              </label>
              <div key={"Act"} className="flex flex-wrap -mx-3 px-3 mb-6 ">
                <div
                  style={{
                    background: Colors.primary,
                  }}
                  className={`w-full px-4 border border-gray-500 activity rounded  py-3 text-gray-700 hover:bg-light-blue-500 hover:text-white cursor-pointer text-white border-0 rounded-t rounded-b-none`}
                >
                  Services
                </div>
                <Card className="flex flex-col items-center content-center rounded-t-none ">
                  {values.Activity !== null &&
                    values.Activity.map(
                      ({ Name, DetailActivity, Detail }, index) => {
                        if (DetailActivity) {
                          if (Name === "PORT_SERVICES") {
                            return DetailActivity.map((keyName, i) => {
                              let mapping = keyName["Name"];

                              if (keyName["Name"] === "Stevedoring") {
                                mapping = "Port_Service_Common";
                              }
                              if (keyName["Name"] === "Liquid") {
                                mapping = "Liquid";
                                keyName["Surname"] = "Liquid Transfer";
                              }
                              if (
                                keyName["Name"] ===
                                  "Receiving_Using_Forklift" ||
                                keyName["Name"] === "Receiving_Using_Crane"
                              ) {
                                mapping = "Port_Service_External";
                              }
                              if (
                                keyName["Name"] === "Delivery_Using_Forklift" ||
                                keyName["Name"] === "Delivery_Using_Crane"
                              ) {
                                mapping = "Port_Service_External";
                              }
                              if (
                                keyName["Name"] === "Delivery" ||
                                keyName["Name"] === "Receiving" ||
                                keyName["Name"] === "Stacking_atau_Restacking"
                              ) {
                                mapping = "Port_Service_External";
                              }
                              if (
                                keyName["Name"] === "Stacking_Using_Crane" ||
                                keyName["Name"] === "Stacking_using_crane"
                              ) {
                                mapping = "Stacking_using_crane";
                              }
                              if (
                                keyName["Name"] === "Stacking_Using_Forklift" ||
                                keyName["Name"] === "Stacking_using_forklift"
                              ) {
                                mapping = "Stacking_using_forklift";
                              }
                              if (keyName["Name"] === "Staging_for_loading") {
                                mapping = "Staging_for_loading";
                              }
                              if (keyName["Name"] === "Stuffing") {
                                mapping = "Stuffing";
                              }
                              if (keyName["Name"] === "Bundling") {
                                mapping = "Bundling";
                              }
                              if (Name === "RENTAL") {
                                mapping = "Rental";
                              }
                              if (Name === "AREA_RENTAL") {
                                mapping = "AREA_RENTAL";
                              }
                              if (Name === "MANPOWER") {
                                mapping = "ManPower";
                              }
                              if (Name === "WASTE_MANAGEMENT_SERVICES") {
                                mapping = "WSM";
                              }
                              if (Name === "Vessel_Service") {
                                mapping = "Vessel_Service";
                              }
                              if (Name === "Vessel_Berthing") {
                                mapping = "Vessel_Berthing";
                              }

                              const simpleObjectDraver = objectDrawer[mapping];
                              if (simpleObjectDraver !== undefined) {
                                return (
                                  <React.Fragment key={`${Name}-${keyName.Name || keyName.Surname || i}-${i}`}>
                                    <hr />
                                    <CardBody className="w-full mt-5 ">
                                      <label className="block uppercase tracking-wide text-gray-700 text-l font-bold mb-2">
                                        {Name.replace(/[_]/g, " ")} -{" "}
                                        {keyName["Surname"].replace(
                                          /[_]/g,
                                          " ",
                                        )}
                                      </label>
                                      <div className="overflow-x-auto">
                                        <button
                                          onClick={() =>
                                            handleInsertServices(
                                              index,
                                              i,
                                              keyName["Surname"],
                                              Name,
                                            )
                                          }
                                          className="flex flex-row items-center justify-center m-2 mt-4 mb-4  bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                                        >
                                          Add
                                        </button>
                                        <table className="table-auto w-full bg-transparent border-collapse ">
                                          <thead>
                                            <tr>
                                              {simpleObjectDraver[
                                                "header_upper"
                                              ] !== null &&
                                                simpleObjectDraver[
                                                  "header_upper"
                                                ]?.map((keyName, idx) => (
                                                  <th
                                                    key={`header-upper-${idx}`}
                                                    rowSpan={keyName["rowSpan"]}
                                                    colSpan={keyName["colSpan"]}
                                                    style={{
                                                      color: Colors.primary,
                                                    }}
                                                    className="font-bold px-2  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                                  >
                                                    {keyName["text"]}
                                                  </th>
                                                ))}
                                            </tr>
                                            <tr>
                                              {simpleObjectDraver["header"] !==
                                                null &&
                                                simpleObjectDraver[
                                                  "header"
                                                ]?.map((keyName, idx) => (
                                                  <th
                                                    key={`header-${idx}`}
                                                    rowSpan={keyName["rowSpan"]}
                                                    colSpan={keyName["colSpan"]}
                                                    style={{
                                                      color: Colors.primary,
                                                    }}
                                                    className="font-bold px-2  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                                  >
                                                    {keyName["text"]}
                                                  </th>
                                                ))}
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {keyName["Detail"] &&
                                              keyName["Detail"].map(
                                                (DetailKey, z) => {
                                                  return (
                                                    <tr key={`detail-${index}-${i}-${z}`}>
                                                      {simpleObjectDraver[
                                                        "body"
                                                      ] !== null &&
                                                        simpleObjectDraver[
                                                          "body"
                                                        ].map((field, fieldIdx) => (
                                                          <React.Fragment key={`field-${index}-${i}-${z}-${fieldIdx}`}>
                                                            {inputGenerator(
                                                              field["name"],
                                                              index,
                                                              i,
                                                              DetailKey[
                                                                field["key"]
                                                              ],
                                                              field["type"],
                                                              z,
                                                              "1",
                                                            )}
                                                          </React.Fragment>
                                                        ))}
                                                    </tr>
                                                  );
                                                },
                                              )}
                                            {/* Footer Summary untuk Port_Service_Common (Stevedoring, dll) - Total Quantity */}
                                            {mapping === "Port_Service_Common" && keyName["Detail"] && keyName["Detail"].length > 0 && (
                                              <tr className="bg-gray-100 font-bold">
                                                <td colSpan="4" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                                  Total Quantity
                                                </td>
                                                <td className="px-2 py-2 border-t border-gray-300 text-center text-green-700">
                                                  {keyName["Detail"].reduce((sum, item) => sum + (Number(item.form4) || 0), 0).toLocaleString("id-ID")}
                                                </td>
                                                <td colSpan="2" className="border-t border-gray-300"></td>
                                              </tr>
                                            )}
                                            {/* Footer Summary untuk Cargodoring - Total Loading Quantity */}
                                            {mapping === "Cargodoring" && keyName["Detail"] && keyName["Detail"].length > 0 && (
                                              <tr className="bg-gray-100 font-bold">
                                                <td colSpan="3" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                                  Total Loading Quantity
                                                </td>
                                                <td className="px-2 py-2 border-t border-gray-300 text-center text-green-700">
                                                  {keyName["Detail"].reduce((sum, item) => sum + (Number(item.form4) || 0), 0).toLocaleString("id-ID")}
                                                </td>
                                                <td colSpan="3" className="border-t border-gray-300"></td>
                                              </tr>
                                            )}
                                            {/* Footer Summary untuk Port_Service_External (Receiving, Delivery, dll) - Total Quantity */}
                                            {mapping === "Port_Service_External" && keyName["Detail"] && keyName["Detail"].length > 0 && (
                                              <tr className="bg-gray-100 font-bold">
                                                <td colSpan="3" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                                  Total Quantity
                                                </td>
                                                <td className="px-2 py-2 border-t border-gray-300 text-center text-green-700">
                                                  {keyName["Detail"].reduce((sum, item) => sum + (Number(item.form4) || 0), 0).toLocaleString("id-ID")}
                                                </td>
                                                <td colSpan="2" className="border-t border-gray-300"></td>
                                              </tr>
                                            )}
                                            {/* Footer Summary untuk Bulk_Transfer / Liquid - Total */}
                                            {(mapping === "Bulk_Transfer" || mapping === "Liquid") && keyName["Detail"] && keyName["Detail"].length > 0 && (
                                              <tr className="bg-gray-100 font-bold">
                                                <td colSpan="6" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                                  Total
                                                </td>
                                                <td className="px-2 py-2 border-t border-gray-300 text-center text-green-700">
                                                  {keyName["Detail"].reduce((sum, item) => {
                                                    const total = (Number(item.form4) || 0) - (Number(item.form3) || 0);
                                                    return sum + total;
                                                  }, 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </td>
                                                <td colSpan="2" className="border-t border-gray-300"></td>
                                              </tr>
                                            )}
                                            {/* Footer Summary untuk Vessel_Berthing - Total Hours */}
                                            {mapping === "Vessel_Berthing" && keyName["Detail"] && keyName["Detail"].length > 0 && (
                                              <tr className="bg-gray-100 font-bold">
                                                <td colSpan="6" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                                  Total Hours
                                                </td>
                                                <td className="px-2 py-2 border-t border-gray-300 text-center text-blue-700">
                                                  {keyName["Detail"].reduce((sum, item) => {
                                                    if (item.date1 && item.date2) {
                                                      const start = new Date(item.date1).getTime();
                                                      const end = new Date(item.date2).getTime();
                                                      if (end > start) {
                                                        const hours = (end - start) / (1000 * 60 * 60);
                                                        const activity = item.form5 ? item.form5.toLowerCase() : "";
                                                        return sum + (activity === "standby" ? Math.min(hours, 4) : hours);
                                                      }
                                                    }
                                                    return sum + (Number(item.form4) || 0);
                                                  }, 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </td>
                                                <td className="px-2 py-2 border-t border-gray-300"></td>
                                              </tr>
                                            )}
                                            {/* Footer Summary untuk Vessel_Service - Total Hours */}
                                            {mapping === "Vessel_Service" && keyName["Detail"] && keyName["Detail"].length > 0 && (
                                              <tr className="bg-gray-100 font-bold">
                                                <td colSpan="6" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                                  Total Hours
                                                </td>
                                                <td className="px-2 py-2 border-t border-gray-300 text-center text-blue-700">
                                                  {keyName["Detail"].reduce((sum, item) => {
                                                    if (item.date1 && item.date2) {
                                                      const start = new Date(item.date1).getTime();
                                                      const end = new Date(item.date2).getTime();
                                                      if (end > start) {
                                                        const hours = (end - start) / (1000 * 60 * 60);
                                                        const activity = item.form5 ? item.form5.toLowerCase() : "";
                                                        return sum + (activity === "standby" ? Math.min(hours, 4) : hours);
                                                      }
                                                    }
                                                    return sum + (Number(item.form4) || 0);
                                                  }, 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </td>
                                                <td className="px-2 py-2 border-t border-gray-300"></td>
                                              </tr>
                                            )}
                                            {/* Footer Summary untuk AREA_RENTAL - Total Rental */}
                                            {mapping === "AREA_RENTAL" && keyName["Detail"] && keyName["Detail"].length > 0 && (
                                              <tr className="bg-gray-100 font-bold">
                                                <td colSpan="10" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                                  Total Rental
                                                </td>
                                                <td className="px-2 py-2 border-t border-gray-300 text-center text-purple-700">
                                                  {keyName["Detail"].reduce((sum, item) => {
                                                    const length = Number(item.form4) || 0;
                                                    const wide = Number(item.form5) || 0;
                                                    const height = Number(item.form6) || 0;
                                                    const qty = Number(item.form2) || 0;
                                                    const totalDimension = length * wide * height;
                                                    const totalRental = totalDimension * qty;
                                                    return sum + totalRental;
                                                  }, 0).toLocaleString("id-ID")}
                                                </td>
                                                <td colSpan="2" className="border-t border-gray-300"></td>
                                              </tr>
                                            )}
                                            {/* Footer Summary untuk Staging_for_loading - Total Area (M2) */}
                                            {mapping === "Staging_for_loading" && keyName["Detail"] && keyName["Detail"].length > 0 && (
                                              <tr className="bg-gray-100 font-bold">
                                                <td colSpan="3" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                                  Total Area (M2)
                                                </td>
                                                <td className="px-2 py-2 border-t border-gray-300 text-center text-purple-700">
                                                  {keyName["Detail"].reduce((sum, item) => sum + (Number(item.form3) || 0), 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </td>
                                                <td colSpan="3" className="border-t border-gray-300"></td>
                                              </tr>
                                            )}
                                            {/* Footer Summary untuk Stacking_Using_Crane - Total Weight */}
                                            {mapping === "Stacking_using_crane" && keyName["Detail"] && keyName["Detail"].length > 0 && (
                                              <tr className="bg-gray-100 font-bold">
                                                <td colSpan="5" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                                  Total Weight (kg)
                                                </td>
                                                <td className="px-2 py-2 border-t border-gray-300 text-center text-green-700">
                                                  {keyName["Detail"].reduce((sum, item) => sum + (Number(item.form5) || 0), 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </td>
                                                <td colSpan="1" className="border-t border-gray-300"></td>
                                              </tr>
                                            )}
                                            {/* Footer Summary untuk Stacking_Using_Forklift - Total Weight */}
                                            {mapping === "Stacking_using_forklift" && keyName["Detail"] && keyName["Detail"].length > 0 && (
                                              <tr className="bg-gray-100 font-bold">
                                                <td colSpan="5" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                                  Total Weight (kg)
                                                </td>
                                                <td className="px-2 py-2 border-t border-gray-300 text-center text-green-700">
                                                  {keyName["Detail"].reduce((sum, item) => sum + (Number(item.form5) || 0), 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </td>
                                                <td colSpan="1" className="border-t border-gray-300"></td>
                                              </tr>
                                            )}
                                            {/* Footer Summary untuk Stuffing - Total (kg) */}
                                            {mapping === "Stuffing" && keyName["Detail"] && keyName["Detail"].length > 0 && (
                                              <tr className="bg-gray-100 font-bold">
                                                <td colSpan="4" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                                  Total (kg)
                                                </td>
                                                <td className="px-2 py-2 border-t border-gray-300 text-center text-green-700">
                                                  {keyName["Detail"].reduce((sum, item) => sum + (Number(item.form4) || 0), 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </td>
                                                <td className="border-t border-gray-300"></td>
                                              </tr>
                                            )}
                                            {/* Footer Summary untuk Bundling - Total (Kg) */}
                                            {mapping === "Bundling" && keyName["Detail"] && keyName["Detail"].length > 0 && (
                                              <tr className="bg-gray-100 font-bold">
                                                <td colSpan="6" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                                  Total (Kg)
                                                </td>
                                                <td className="px-2 py-2 border-t border-gray-300 text-center text-green-700">
                                                  {keyName["Detail"].reduce((sum, item) => sum + (Number(item.form7) || 0), 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </td>
                                                <td className="border-t border-gray-300"></td>
                                              </tr>
                                            )}
                                            {/* Footer Summary untuk MANPOWER - Total */}
                                            {mapping === "ManPower" && keyName["Detail"] && keyName["Detail"].length > 0 && (
                                              <tr className="bg-gray-100 font-bold">
                                                <td colSpan="6" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                                  Total
                                                </td>
                                                <td className="px-2 py-2 border-t border-gray-300 text-center text-purple-700">
                                                  {keyName["Detail"].reduce((sum, item) => {
                                                    // Total = Total Hour (form5 manual) × Total Manpower (form2)
                                                    const totalHours = Number(item.form5) || 0;
                                                    const totalManpower = Number(item.form2) || 0;
                                                    const total = totalHours * totalManpower;
                                                    return sum + total;
                                                  }, 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </td>
                                                <td colSpan="2" className="border-t border-gray-300"></td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </CardBody>
                                  </React.Fragment>
                                );
                              }
                            });
                          } else if (Name === "GENERAL_SERVICE") {
                            return GMArray.map(
                              ({ id, DetailUnit }, detailID) => {
                                return (
                                  DetailActivity !== null &&
                                  DetailActivity.map((keyName, i) => {
                                    let mapping = keyName["DetailUnit"];
                                    let units = keyName["DetailUnit"];

                                    if (mapping === "Others") {
                                      if (
                                        keyName["Name"] === "Material Supply"
                                      ) {
                                        units = "Material_Supply";
                                        mapping = "Material_Supply";
                                      } else {
                                        mapping = keyName["Name"];
                                        units = keyName["Name"];
                                      }
                                    }

                                    const simpleObjectDraver =
                                      objectDrawer[mapping];
                                    if (
                                      units === DetailUnit &&
                                      simpleObjectDraver !== undefined
                                    ) {
                                      let subs = "5";

                                      if (keyName["DetailUnit"] === "ROOM") {
                                        subs = "7";
                                      } else if (
                                        keyName["DetailUnit"] === "MEALS"
                                      ) {
                                        subs = "8";
                                      } else if (
                                        keyName["DetailUnit"] === "WOODEN"
                                      ) {
                                        subs = "9";
                                      } else if (
                                        keyName["DetailUnit"] === "Drill"
                                      ) {
                                        subs = "10";
                                      } else if (
                                        keyName["DetailUnit"] === "Others"
                                      ) {
                                        subs = "11";
                                      } else if (
                                        keyName["DetailUnit"] === "Vehicle"
                                      ) {
                                        subs = "12";
                                      }
                                      if (id === "Clearance Doc") {
                                        subs = "15";
                                      }
                                      if (id === "Material Supply") {
                                        subs = "16";
                                      }

                                      // 🔥 HITUNG TOTAL MEAL KHUSUS UNTUK MEALS
                                      let totalMealSummary = 0;
                                      if (
                                        DetailUnit === "MEALS" &&
                                        keyName["Detail"]
                                      ) {
                                        totalMealSummary = keyName[
                                          "Detail"
                                        ].reduce((sum, item) => {
                                          return (
                                            sum + (Number(item.form6) || 0)
                                          );
                                        }, 0);
                                      }

                                      return (
                                        <React.Fragment key={`${Name}-${id}-${detailID}-${i}`}>
                                          <hr />
                                          <CardBody className="w-full mt-5 ">
                                            <label className="block uppercase tracking-wide text-gray-700 text-l font-bold mb-2">
                                              {Name.replace(/[_]/g, " ")} - {id}
                                            </label>
                                            <div className="overflow-x-auto">
                                              <button
                                                onClick={() =>
                                                  handleInsertServices(index, i)
                                                }
                                                className="flex flex-row items-center justify-center m-2 mt-4 mb-4  bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                                              >
                                                Add
                                              </button>
                                              <table className="table-auto w-full bg-transparent border-collapse ">
                                                <thead>
                                                  <tr>
                                                    {simpleObjectDraver[
                                                      "header_upper"
                                                    ] !== null &&
                                                      simpleObjectDraver[
                                                        "header_upper"
                                                    ]?.map((keyName, idx) => (
                                                        <th
                                                          key={`header-upper-${idx}`}
                                                          rowSpan={
                                                            keyName["rowSpan"]
                                                          }
                                                          colSpan={
                                                            keyName["colSpan"]
                                                          }
                                                          style={{
                                                            color:
                                                              Colors.primary,
                                                          }}
                                                          className="font-bold px-2  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                                        >
                                                          {keyName["text"]}
                                                        </th>
                                                      ))}
                                                  </tr>
                                                  <tr>
                                                    {simpleObjectDraver[
                                                      "header"
                                                    ] !== null &&
                                                      simpleObjectDraver[
                                                        "header"
                                                    ]?.map((keyName, idx) => (
                                                        <th
                                                          key={`header-${idx}`}
                                                          rowSpan={
                                                            keyName["rowSpan"]
                                                          }
                                                          colSpan={
                                                            keyName["colSpan"]
                                                          }
                                                          style={{
                                                            color:
                                                              Colors.primary,
                                                          }}
                                                          className="font-bold px-2  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                                        >
                                                          {keyName["text"]}
                                                        </th>
                                                      ))}
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {keyName["Detail"] &&
                                                    keyName["Detail"].map(
                                                      (DetailKey, z) => {
                                                        return (
                                                          <tr
                                                            key={`detail-${index}-${i}-${z}`}
                                                          >
                                                            {simpleObjectDraver[
                                                              "body"
                                                            ] !== null &&
                                                              simpleObjectDraver[
                                                                "body"
                                                              ].map((field, fieldIdx) => (
                                                                <React.Fragment key={`field-${index}-${i}-${z}-${fieldIdx}`}>
                                                                  {inputGenerator(
                                                                    field["name"],
                                                                    index,
                                                                    i,
                                                                    DetailKey[
                                                                      field["key"]
                                                                    ],
                                                                    field["type"],
                                                                    z,
                                                                    subs,
                                                                  )}
                                                                </React.Fragment>
                                                              ))}
                                                          </tr>
                                                        );
                                                      },
                                                    )}

                                                  {/* 🔥 BARIS TOTAL UNTUK MEALS */}
                                                  {DetailUnit === "MEALS" &&
                                                    keyName["Detail"]?.length >
                                                      0 && (
                                                      <tr className="bg-gray-100 font-bold">
                                                        <td
                                                          colSpan="6"
                                                          className="text-right px-2 py-2 border-t border-gray-300"
                                                        >
                                                          Total:
                                                        </td>
                                                        <td className="text-right px-2 py-2 border-t border-gray-300">
                                                          {totalMealSummary.toLocaleString(
                                                            "id-ID",
                                                          )}
                                                        </td>
                                                        <td
                                                          colSpan="4"
                                                          className="border-t border-gray-300"
                                                        ></td>
                                                      </tr>
                                                    )}

                                                  {/* 🔥 FOOTER SUMMARY untuk GENERAL_SERVICE - Room - Total Days */}
                                                  {DetailUnit === "ROOM" &&
                                                    keyName["Detail"]?.length > 0 && (
                                                      <tr className="bg-gray-100 font-bold">
                                                        <td
                                                          colSpan="6"
                                                          className="text-right px-2 py-2 border-t border-gray-300 text-sm uppercase"
                                                        >
                                                          Total Days
                                                        </td>
                                                        <td className="text-right px-2 py-2 border-t border-gray-300 text-blue-700">
                                                          {keyName["Detail"].reduce((sum, item) => {
                                                            // diff_Day sudah menambahkan +1 secara internal
                                                            const totalDays = diff_Day(item.date1, item.date2);
                                                            return sum + totalDays;
                                                          }, 0).toLocaleString("id-ID")}
                                                        </td>
                                                        <td
                                                          colSpan="4"
                                                          className="border-t border-gray-300"
                                                        ></td>
                                                      </tr>
                                                    )}
                                                  {/* 🔥 FOOTER SUMMARY untuk Total (GENERAL_SERVICE - Vehicle) */}
                                                  {DetailUnit === "Vehicle" &&
                                                    keyName["Detail"]?.length > 0 && (
                                                      <tr className="bg-gray-100 font-bold">
                                                        <td
                                                          colSpan="7"
                                                          className="text-right px-2 py-2 border-t border-gray-300 text-sm uppercase"
                                                        >
                                                          Total
                                                        </td>
                                                        <td className="text-right px-2 py-2 border-t border-gray-300 text-blue-700">
                                                          {keyName["Detail"].reduce((sum, item) => {
                                                            const days = diff_Day(item.date1, item.date2);
                                                            const qty = Number(item.form3) || 0;
                                                            const total = days * qty;
                                                            return sum + total;
                                                          }, 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </td>
                                                        <td
                                                          colSpan="2"
                                                          className="border-t border-gray-300"
                                                        ></td>
                                                      </tr>
                                                    )}
                                                  {/* 🔥 FOOTER SUMMARY untuk GENERAL_SERVICE - Laundry */}
                                                  {DetailUnit === "LAUNDRY" && keyName["Detail"]?.length > 0 && (
                                                    <tr className="bg-gray-100 font-bold">
                                                      <td colSpan="2" className="text-right px-2 py-2 border-t border-gray-300 text-sm uppercase">
                                                        Total Weight (kg)
                                                      </td>
                                                      <td className="text-right px-2 py-2 border-t border-gray-300 text-green-700">
                                                        {keyName["Detail"].reduce((sum, item) => sum + (Number(item.form6) || 0), 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                      </td>
                                                      <td colSpan="6" className="border-t border-gray-300"></td>
                                                    </tr>
                                                  )}
                                                  {/* 🔥 FOOTER SUMMARY untuk GENERAL_SERVICE - Wooden Dunnage & Pallet Wrapping */}
                                                  {DetailUnit === "WOODEN" && keyName["Detail"]?.length > 0 && (
                                                    <tr className="bg-gray-100 font-bold">
                                                      <td colSpan="5" className="text-right px-2 py-2 border-t border-gray-300 text-sm uppercase">
                                                        Total Quantity
                                                      </td>
                                                      <td className="text-right px-2 py-2 border-t border-gray-300 text-green-700">
                                                        {keyName["Detail"].reduce((sum, item) => sum + (Number(item.form3) || 0), 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                      </td>
                                                      <td colSpan="3" className="border-t border-gray-300"></td>
                                                    </tr>
                                                  )}
                                                  {/* 🔥 FOOTER SUMMARY untuk GENERAL_SERVICE - Drill & Fresh Water - Total */}
                                                  {DetailUnit === "Drill" && keyName["Detail"]?.length > 0 && (
                                                    <tr className="bg-gray-100 font-bold">
                                                      <td colSpan="6" className="text-right px-2 py-2 border-t border-gray-300 text-sm uppercase">
                                                        Total
                                                      </td>
                                                      <td className="text-right px-2 py-2 border-t border-gray-300 text-green-700">
                                                        {keyName["Detail"].reduce((sum, item) => {
                                                          const end = Number(item.form4) || 0;
                                                          const start = Number(item.form5) || 0;
                                                          return sum + Math.abs(end - start);
                                                        }, 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                      </td>
                                                      <td colSpan="4" className="border-t border-gray-300"></td>
                                                    </tr>
                                                  )}
                                                  {/* 🔥 FOOTER SUMMARY untuk GENERAL_SERVICE - Fuel - Total */}
                                                  {DetailUnit === "Fuel" && keyName["Detail"]?.length > 0 && (
                                                    <tr className="bg-gray-100 font-bold">
                                                      <td colSpan="6" className="text-right px-2 py-2 border-t border-gray-300 text-sm uppercase">
                                                        Total
                                                      </td>
                                                      <td className="text-right px-2 py-2 border-t border-gray-300 text-green-700">
                                                        {keyName["Detail"].reduce((sum, item) => {
                                                          const end = Number(item.form4) || 0;
                                                          const start = Number(item.form3) || 0;
                                                          return sum + (end - start);
                                                        }, 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                      </td>
                                                      <td colSpan="4" className="border-t border-gray-300"></td>
                                                    </tr>
                                                  )}
                                                  {/* 🔥 FOOTER SUMMARY untuk GENERAL_SERVICE - Clearance Doc - Total Quantity */}
                                                  {(DetailUnit === "ClearanceDoc" || DetailUnit === "Clearance Doc" || DetailUnit === "Clearance_Doc") && keyName["Detail"]?.length > 0 && (
                                                    <tr className="bg-gray-100 font-bold">
                                                      <td colSpan="6" className="text-right px-2 py-2 border-t border-gray-300 text-sm uppercase">
                                                        Total Quantity
                                                      </td>
                                                      <td className="text-right px-2 py-2 border-t border-gray-300 text-green-700">
                                                        {keyName["Detail"].reduce((sum, item) => sum + (Number(item.form4) || 0), 0).toLocaleString("id-ID")}
                                                      </td>
                                                      <td colSpan="4" className="border-t border-gray-300"></td>
                                                    </tr>
                                                  )}
                                                  {/* 🔥 FOOTER SUMMARY untuk GENERAL_SERVICE - Material Supply - Total Quantity */}
                                                  {DetailUnit === "Material_Supply" && keyName["Detail"]?.length > 0 && (
                                                    <tr className="bg-gray-100 font-bold">
                                                      <td colSpan="3" className="text-right px-2 py-2 border-t border-gray-300 text-sm uppercase">
                                                        Total Quantity
                                                      </td>
                                                      <td className="text-right px-2 py-2 border-t border-gray-300 text-green-700">
                                                        {keyName["Detail"].reduce((sum, item) => sum + (Number(item.form2) || 0), 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                      </td>
                                                      <td colSpan="2" className="border-t border-gray-300"></td>
                                                    </tr>
                                                  )}
                                                </tbody>
                                              </table>
                                            </div>
                                          </CardBody>
                                        </React.Fragment>
                                      );
                                    }
                                  })
                                );
                              },
                            );
                          } else {
                            const simpleObjectDraver = objectDrawer[Name];
                            if (simpleObjectDraver !== undefined) {
                              let subs = "2";
                              if (Name === "RENTAL") {
                                subs = "2";
                              } else if (Name === "WASTE_MANAGEMENT_SERVICES") {
                                subs = "3";
                              } else if (Name === "AREA_RENTAL") {
                                subs = "4";
                              } else if (Name === "GENERAL_SERVICE") {
                                subs = "5";
                              } else if (Name === "MANPOWER") {
                                subs = "6";
                              }
                              return (
                                <React.Fragment key={`${Name}-${index}`}>
                                <CardBody className="w-full mt-5 ">
                                  <label className="block uppercase tracking-wide text-gray-700 text-l font-bold mb-2">
                                    {Name.replace(/[_]/g, " ")}
                                  </label>
                                  <div className="overflow-x-auto">
                                    <button
                                      onClick={() =>
                                        handleInsertServices(index, -1)
                                      }
                                      className="flex flex-row items-center justify-center m-2 mt-4 mb-4  bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                                    >
                                      Add
                                    </button>
                                    <hr />
                                    <table className="table-auto w-full bg-transparent border-collapse ">
                                      <thead>
                                        <tr>
                                          {simpleObjectDraver[
                                            "header_upper"
                                          ] !== null &&
                                            simpleObjectDraver[
                                              "header_upper"
                                            ]?.map((keyName, idx) => (
                                              <th
                                                key={`header-upper-${idx}`}
                                                rowSpan={keyName["rowSpan"]}
                                                colSpan={keyName["colSpan"]}
                                                style={{
                                                  color: Colors.primary,
                                                }}
                                                className="font-bold px-2  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                              >
                                                {keyName["text"]}
                                              </th>
                                            ))}
                                        </tr>
                                        <tr>
                                          {simpleObjectDraver["header"] !==
                                            null &&
                                            simpleObjectDraver["header"]?.map(
                                              (keyName, idx) => (
                                                <th
                                                  key={`header-${idx}`}
                                                  rowSpan={keyName["rowSpan"]}
                                                  colSpan={keyName["colSpan"]}
                                                  style={{
                                                    color: Colors.primary,
                                                  }}
                                                  className="font-bold px-2  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                                >
                                                  {keyName["text"]}
                                                </th>
                                              ),
                                            )}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {Detail &&
                                          Detail.map((DetailKey, z) => {
                                            return (
                                              <tr key={`detail-${index}-${z}`}>
                                                {simpleObjectDraver["body"] !==
                                                  null &&
                                                  simpleObjectDraver[
                                                    "body"
                                                  ].map((field, fieldIdx) => (
                                                    <React.Fragment key={`field-${index}-${z}-${fieldIdx}`}>
                                                      {inputGenerator(
                                                        field["name"],
                                                        index,
                                                        -1,
                                                        DetailKey[field["key"]],
                                                        field["type"],
                                                        z,
                                                        subs,
                                                      )}
                                                    </React.Fragment>
                                                  ))}
                                              </tr>
                                            );
                                          })}
                                        {/* 🔥 FOOTER SUMMARY untuk Total (RENTAL) */}
                                        {Name === "RENTAL" && Detail && Detail.length > 0 && (
                                          <tr className="bg-gray-100 font-bold">
                                            <td colSpan="6" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                              Total
                                            </td>
                                            <td className="px-2 py-2 border-t border-gray-300 text-center text-blue-700">
                                              {Detail.reduce((sum, item, itemIdx) => {
                                                // Gunakan OumListener untuk mendapatkan label UoM
                                                const oumLabel = (OumListener[itemIdx] || item.form4 || "").toLowerCase().replace(/\s+/g, '');
                                                const qty = Number(item.form6) || 0;
                                                
                                                if (!oumLabel || oumLabel === "") {
                                                  return sum;
                                                }
                                                
                                                if (oumLabel === "trip") {
                                                  return sum + qty;
                                                }
                                                
                                                if (item.date1 && item.date2) {
                                                  const dt1 = new Date(item.date1);
                                                  const dt2 = new Date(item.date2);
                                                  
                                                  if (!isNaN(dt1.getTime()) && !isNaN(dt2.getTime())) {
                                                    const diffMs = Math.abs(dt2.getTime() - dt1.getTime());
                                                    const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
                                                    
                                                    if (oumLabel.includes("hour")) {
                                                      return sum + ((diffHrs + 1) * qty);
                                                    } else {
                                                      let days = Math.floor(diffHrs / 24);
                                                      if (diffHrs % 24 > 0) days += 1;
                                                      return sum + (days * qty);
                                                    }
                                                  }
                                                }
                                                return sum;
                                              }, 0).toLocaleString("id-ID", { minimumFractionDigits: 1, maximumFractionDigits: 1 })}
                                            </td>
                                            <td colSpan="3" className="border-t border-gray-300"></td>
                                          </tr>
                                        )}
                                        {/* 🔥 FOOTER SUMMARY untuk Total Rental - AREA_RENTAL */}
                                        {Name === "AREA_RENTAL" && Detail && Detail.length > 0 && (
                                          <tr className="bg-gray-100 font-bold">
                                            <td colSpan="10" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                              Total Rental
                                            </td>
                                            <td className="px-2 py-2 border-t border-gray-300 text-center text-purple-700">
                                              {Detail.reduce((sum, item) => {
                                                const length = Number(item.form4) || 0;
                                                const wide = Number(item.form5) || 0;
                                                const height = Number(item.form6) || 0;
                                                const qty = Number(item.form2) || 0;
                                                const totalDimension = length * wide * height;
                                                const totalRental = totalDimension * qty;
                                                return sum + totalRental;
                                              }, 0).toLocaleString("id-ID")}
                                            </td>
                                            <td colSpan="2" className="border-t border-gray-300"></td>
                                          </tr>
                                        )}
                                        {/* 🔥 FOOTER SUMMARY untuk Total - MANPOWER */}
                                        {Name === "MANPOWER" && Detail && Detail.length > 0 && (
                                          <tr className="bg-gray-100 font-bold">
                                            <td colSpan="6" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                              Total
                                            </td>
                                            <td className="px-2 py-2 border-t border-gray-300 text-center text-purple-700">
                                              {Detail.reduce((sum, item) => {
                                                // Total = Total Hour (form5 manual) × Total Manpower (form2)
                                                const totalHours = Number(item.form5) || 0;
                                                const totalManpower = Number(item.form2) || 0;
                                                const total = totalHours * totalManpower;
                                                return sum + total;
                                              }, 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </td>
                                            <td colSpan="2" className="border-t border-gray-300"></td>
                                          </tr>
                                        )}
                                        {/* 🔥 FOOTER SUMMARY untuk Total Quantity - WASTE_MANAGEMENT_SERVICES */}
                                        {Name === "WASTE_MANAGEMENT_SERVICES" && Detail && Detail.length > 0 && (
                                          <tr className="bg-gray-100 font-bold">
                                            <td colSpan="5" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                              Total Quantity
                                            </td>
                                            <td className="px-2 py-2 border-t border-gray-300 text-center text-green-700">
                                              {Detail.reduce((sum, item) => sum + (Number(item.form5) || 0), 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </td>
                                            <td colSpan="2" className="border-t border-gray-300"></td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </CardBody>
                                </React.Fragment>
                              );
                            }
                          }
                        }
                      },
                    )}
                </Card>
              </div>
            </div>
            {/* ────────────────────────────────────────────────────────────── */}
            {/* SUMMARY TOTAL SECTION */}
            {/* ────────────────────────────────────────────────────────────── */}
            <div className="p-4 mt-6">
              <Card className="shadow-lg">
                <CardBody>
                  <label className="block uppercase tracking-wide text-gray-700 text-xl font-bold mb-4">
                    Activity Summary
                  </label>
                  <div className="overflow-x-auto">
                    <table className="table-auto w-full bg-transparent border-collapse">
                      <thead>
                        <tr>
                          <th
                            style={{ color: Colors.primary }}
                            className="font-bold px-4 py-3 text-base whitespace-nowrap text-left border-b-2 border-gray-300 bg-gray-50"
                          >
                            No
                          </th>
                          <th
                            style={{ color: Colors.primary }}
                            className="font-bold px-4 py-3 text-base whitespace-nowrap text-left border-b-2 border-gray-300 bg-gray-50"
                          >
                            Activity Type
                          </th>
                          <th
                            style={{ color: Colors.primary }}
                            className="font-bold px-4 py-3 text-base whitespace-nowrap text-center border-b-2 border-gray-300 bg-gray-50"
                          >
                            Total Items
                          </th>
                          <th
                            style={{ color: Colors.primary }}
                            className="font-bold px-4 py-3 text-base whitespace-nowrap text-center border-b-2 border-gray-300 bg-gray-50"
                          >
                            Total Quantity
                          </th>
                          <th
                            style={{ color: Colors.primary }}
                            className="font-bold px-4 py-3 text-base whitespace-nowrap text-left border-b-2 border-gray-300 bg-gray-50"
                          >
                            Details
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {(() => {
                          let summaryNo = 0;
                          let grandTotalItems = 0;
                          let grandTotalQuantity = 0;
                          const summaryRows = [];

                          values.Activity?.forEach((activity, actIdx) => {
                            const activityName = activity.Name;
                            let totalItems = 0;
                            let totalQuantity = 0;
                            const details = [];

                            // PORT_SERVICES: iterate DetailActivity
                            if (activityName === "PORT_SERVICES") {
                              activity.DetailActivity?.forEach((subActivity) => {
                                if (!subActivity.Detail || subActivity.Detail.length === 0) return;
                                const subName = subActivity.Name || "Unknown";
                                const itemCount = subActivity.Detail.length;
                                totalItems += itemCount;

                                // Count quantity from form4 (Quantity field)
                                let subQty = 0;
                                subActivity.Detail.forEach(item => {
                                  subQty += Number(item.form4) || 0;
                                });
                                totalQuantity += subQty;

                                if (itemCount > 0) {
                                  details.push(`${subName}: ${itemCount} items`);
                                }
                              });
                            }
                            // GENERAL_SERVICE: iterate DetailActivity with CategoryFlag
                            else if (activityName === "GENERAL_SERVICE") {
                              activity.DetailActivity?.forEach((subActivity) => {
                                if (!subActivity.Detail || subActivity.Detail.length === 0) return;
                                const subName = subActivity.DetailUnit || subActivity.Name || "Unknown";
                                const itemCount = subActivity.Detail.length;
                                totalItems += itemCount;

                                let subQty = 0;
                                subActivity.Detail.forEach(item => {
                                  subQty += Number(item.form4) || Number(item.form6) || 0;
                                });
                                totalQuantity += subQty;

                                if (itemCount > 0) {
                                  details.push(`${subName}: ${itemCount} items`);
                                }
                              });
                            }
                            // OTHER SERVICES: RENTAL, WASTE_MANAGEMENT, AREA_RENTAL, MANPOWER, Vessel_Berthing
                            else {
                              if (!activity.Detail || activity.Detail.length === 0) return;
                              const itemCount = activity.Detail.length;
                              totalItems = itemCount;

                              // Extract quantity based on service type
                              activity.Detail.forEach(item => {
                                // RENTAL: form6, AREA_RENTAL: form2, WSM: form5, MANPOWER: calculated
                                let qty = 0;
                                if (activityName === "RENTAL") {
                                  qty = Number(item.form6) || 0;
                                } else if (activityName === "AREA_RENTAL") {
                                  qty = Number(item.form2) || 0;
                                } else if (activityName === "WASTE_MANAGEMENT_SERVICES") {
                                  qty = Number(item.form5) || 0;
                                } else if (activityName === "MANPOWER") {
                                  // Total = Total Hour (form5 manual) × Total Manpower (form2)
                                  const totalHours = Number(item.form5) || 0;
                                  const totalManpower = Number(item.form2) || 0;
                                  qty = totalHours * totalManpower;
                                } else {
                                  qty = Number(item.form6) || 0;
                                }
                                totalQuantity += qty;
                              });
                            }

                            grandTotalItems += totalItems;
                            grandTotalQuantity += totalQuantity;

                            if (totalItems > 0) {
                              summaryNo++;
                              summaryRows.push(
                                <tr key={`summary-${actIdx}`} className="hover:bg-gray-50">
                                  <td className="px-4 py-3 border-b border-gray-200 text-sm">
                                    {summaryNo}
                                  </td>
                                  <td className="px-4 py-3 border-b border-gray-200 text-sm font-semibold">
                                    {activityName.replace(/[_]/g, " ")}
                                  </td>
                                  <td className="px-4 py-3 border-b border-gray-200 text-sm text-center">
                                    <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full font-semibold">
                                      {totalItems}
                                    </span>
                                  </td>
                                  <td className="px-4 py-3 border-b border-gray-200 text-sm text-center">
                                    <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full font-semibold">
                                      {totalQuantity.toLocaleString("id-ID")}
                                    </span>
                                  </td>
                                  <td className="px-4 py-3 border-b border-gray-200 text-xs text-gray-600">
                                    {details.length > 0 ? details.join(" | ") : "-"}
                                  </td>
                                </tr>
                              );
                            }
                          });

                          return (
                            <>
                              {summaryRows}
                              {summaryRows.length > 0 && (
                                <tr className="bg-gray-200 font-bold">
                                  <td colSpan="2" className="px-4 py-3 text-right text-sm uppercase">
                                    Grand Total
                                  </td>
                                  <td className="px-4 py-3 text-center text-sm">
                                    <span className="bg-blue-600 text-white px-4 py-1 rounded-full">
                                      {grandTotalItems}
                                    </span>
                                  </td>
                                  <td className="px-4 py-3 text-center text-sm">
                                    <span className="bg-green-600 text-white px-4 py-1 rounded-full">
                                      {grandTotalQuantity.toLocaleString("id-ID")}
                                    </span>
                                  </td>
                                  <td className="px-4 py-3 text-xs text-gray-700">
                                    {summaryRows.length} activity type(s)
                                  </td>
                                </tr>
                              )}
                              {summaryRows.length === 0 && (
                                <tr>
                                  <td colSpan="5" className="px-4 py-8 text-center text-gray-500 italic">
                                    No activity data available. Please select and fill in at least one activity.
                                  </td>
                                </tr>
                              )}
                            </>
                          );
                        })()}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </div>
            {/*Eqipment*/}
            {checkedState && (
              <>
                {/*Labour*/}

                {/*Truck*/}

                <Modal
                  active={modalShippingManifest}
                  toggler={() => {
                    setModalShippingManifest(true);
                  }}
                >
                  <ModalHeader
                    className="mt-20"
                    toggler={() => {
                      setModalShippingManifest(false);
                    }}
                  >
                    Shipping Manifest
                  </ModalHeader>
                  <ModalBody>
                    {values.ShippingManifestDetail && (
                      <div className="p-4">
                        {values["ShippingManifestDetail"].SupportingFile !==
                          "" && (
                          <div className="flex flex-wrap -mx-3 mb-6">
                            <div className=" px-3 mb-6 md:mb-0">
                              <label className="block uppercase tracking-wide text-light-green-700 text-xs font-bold mb-2 ">
                                Existing Supporting File *
                              </label>

                              <button
                                onClick={() =>
                                  getDataFromURL(
                                    values["ShippingManifestDetail"]
                                      .SupportingFile,
                                  )
                                }
                                className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                              >
                                <BiPrinter className="text-xl text-gray-800 mr-2" />
                                <span>Download Supporting File JR</span>
                              </button>
                            </div>
                          </div>
                        )}
                        <div className="flex flex-wrap -mx-3 mb-6">
                          <div className="w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-light-green-700 text-xs font-bold mb-2 ">
                              Vessel Name *
                            </label>
                            <input
                              disabled={true}
                              value={
                                values["ShippingManifestDetail"].VesselName
                              }
                              name="VesselName"
                              className={
                                (values["ShippingManifestDetail"].VesselName ||
                                  buttonTouched) &&
                                errors.ShippingManifest
                                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                              }
                              type="text"
                            />
                          </div>
                        </div>
                        <div className="flex flex-wrap -mx-3 mb-6">
                          <div className="w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-light-green-700 text-xs font-bold mb-2 ">
                              Master Name *
                            </label>
                            <input
                              value={
                                values["ShippingManifestDetail"].MasterName
                              }
                              disabled={true}
                              name="MasterName"
                              className={
                                (values["ShippingManifestDetail"].MasterName ||
                                  buttonTouched) &&
                                errors.ShippingManifest
                                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                              }
                              type="text"
                            />
                          </div>
                        </div>
                        <div className="flex flex-wrap -mx-3 mb-6">
                          <div className="w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-light-green-700 text-xs font-bold mb-2 ">
                              Owner Vessel *
                            </label>
                            <input
                              disabled={true}
                              value={
                                values["ShippingManifestDetail"].OwnerVessel
                              }
                              name="OwnerVessel"
                              className={
                                (values["ShippingManifestDetail"].OwnerVessel ||
                                  buttonTouched) &&
                                errors.ShippingManifest
                                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                              }
                              type="text"
                            />
                          </div>
                        </div>
                        <div className="flex flex-wrap -mx-3 mb-6">
                          <div className="w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-light-green-700 text-xs font-bold mb-2 ">
                              Ship Agent
                            </label>
                            <input
                              disabled={true}
                              value={values["ShippingManifestDetail"].ShipAgent}
                              name="ShipAgent"
                              className={
                                (values["ShippingManifestDetail"].ShipAgent ||
                                  buttonTouched) &&
                                errors.ShippingManifest
                                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                              }
                              type="text"
                            />
                          </div>
                        </div>
                        <div className="flex flex-wrap -mx-3 mb-6">
                          <div className="w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-light-green-700 text-xs font-bold mb-2 ">
                              Flag *
                            </label>
                            <input
                              disabled={true}
                              value={values["ShippingManifestDetail"].Flag}
                              name="Flag"
                              className={
                                (values["ShippingManifestDetail"].Flag ||
                                  buttonTouched) &&
                                errors.ShippingManifest
                                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                              }
                              type="text"
                            />
                          </div>
                          <div className="w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-light-green-700 text-xs font-bold mb-2 ">
                              Port Registry *
                            </label>
                            <input
                              disabled={true}
                              value={
                                values["ShippingManifestDetail"].PortRegistry
                              }
                              name="PortRegistry"
                              className={
                                (values["ShippingManifestDetail"]
                                  .PortRegistry ||
                                  buttonTouched) &&
                                errors.ShippingManifest
                                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                              }
                              type="text"
                            />
                          </div>
                        </div>
                        <div className="flex flex-wrap -mx-3 mb-6">
                          <div className="w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-light-green-700 text-xs font-bold mb-2 ">
                              Port Departure *
                            </label>
                            <input
                              disabled={true}
                              value={
                                values["ShippingManifestDetail"].PortDepature
                              }
                              name="PortDepature"
                              className={
                                (values["ShippingManifestDetail"]
                                  .PortDepature ||
                                  buttonTouched) &&
                                errors.ShippingManifest
                                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                              }
                              type="text"
                            />
                          </div>
                          <div className="w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-light-green-700 text-xs font-bold mb-2 ">
                              ETA *
                            </label>
                            <DatePicker
                              showTimeInput
                              dateFormat="dd-MM-yyyy HH:mm"
                              selected={
                                new Date(
                                  values["ShippingManifestDetail"]?.Eta &&
                                  values["ShippingManifestDetail"].Eta !== "" &&
                                  !isNaN(new Date(values["ShippingManifestDetail"].Eta).getTime())
                                    ? values["ShippingManifestDetail"].Eta
                                    : new Date(),
                                )
                              }
                              disabled={true}
                              className={
                                (values["ShippingManifestDetail"].Eta ||
                                  buttonTouched) &&
                                errors.ShippingManifest
                                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                              }
                            />
                          </div>
                        </div>
                        <div className="flex flex-wrap -mx-3 mb-6">
                          <div className="w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-light-green-700 text-xs font-bold mb-2 ">
                              Quantity *
                            </label>
                            <input
                              value={values["ShippingManifestDetail"].Quantity}
                              disabled={true}
                              name="Quantity"
                              className={
                                (values["ShippingManifestDetail"].Quantity ||
                                  buttonTouched) &&
                                errors.ShippingManifest
                                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                              }
                              type="text"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      color="green"
                      buttonType="link"
                      onClick={() => {
                        setModalShippingManifest(false);
                      }}
                      ripple="green"
                    >
                      Close
                    </Button>
                  </ModalFooter>
                </Modal>
              </>
            )}
          </div>
        </div>
      </>
    );
  }
};
export default OperationalOutputDetail;
